var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSbt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2992 21.1187H27.4846V29.1093H27.2992L27.2251 29.0351V21.1928L27.2992 21.1187Z",
    fill: "url(#paint0_linear_240_33903)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5222 23.7514L30.2635 23.1768L31.1902 24.938L30.7268 26.8847L29.5222 26.4768L28.1132 24.9414L29.4481 23.7514H29.5222Z",
    fill: "url(#paint1_linear_240_33903)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.338 23.251H29.5233V26.9775H29.338L26.7928 24.8664L29.2639 23.3251L29.338 23.251Z",
    fill: "url(#paint2_linear_240_33903)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1521 22.8804H29.3375V27.3484H29.1521L29.078 27.2743V22.9545L29.1521 22.8804Z",
    fill: "url(#paint3_linear_240_33903)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9664 22.5649H29.1518V27.6448H28.9664L26.4114 25.0394L28.8923 22.6391L28.9664 22.5649Z",
    fill: "url(#paint4_linear_240_33903)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.781 22.3237H28.9664V27.9042H28.781L28.7069 27.83V22.3979L28.781 22.3237Z",
    fill: "url(#paint5_linear_240_33903)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5957 22.1016H28.781V28.127H28.5957L25.9022 24.8887L28.5215 22.1757L28.5957 22.1016Z",
    fill: "url(#paint6_linear_240_33903)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4111 21.8975H28.5964V28.3123H28.4111L26.4491 25.4102L28.337 21.9716L28.4111 21.8975Z",
    fill: "url(#paint7_linear_240_33903)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.226 21.7305H28.4113V28.4789H28.226L25.3843 24.7166L28.1518 21.8046L28.226 21.7305Z",
    fill: "url(#paint8_linear_240_33903)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0406 21.5825H28.2259V28.6277H28.0406L25.2681 28.2865L25.3175 21.6468L28.0406 21.5825Z",
    fill: "url(#paint9_linear_240_33903)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8551 21.4341H28.0404V28.7758H27.8551L25.9326 28.7017L25.8931 21.7369L27.8551 21.4341Z",
    fill: "url(#paint10_linear_240_33903)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6698 21.3229H27.8551V28.8872H27.6698L26.8457 28.4385L25.4817 21.3081L27.6698 21.3229Z",
    fill: "url(#paint11_linear_240_33903)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.484 21.2116H27.6693V28.9983H27.484L25.3046 27.4608V21.0781L27.484 21.2116Z",
    fill: "url(#paint12_linear_240_33903)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2991 21.1189H27.4844V29.1095H27.2991L25.8017 29.2232L25.5546 20.9458L27.2991 21.1189Z",
    fill: "url(#paint13_linear_240_33903)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1137 21.0259H27.299V29.2019H27.1137L25.4087 26.6459L26.8419 21.5747L27.1137 21.0259Z",
    fill: "url(#paint14_linear_240_33903)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9286 20.9518H27.1139V29.2762H26.9286L25.4806 29.7953L25.4312 20.502L26.9286 20.9518Z",
    fill: "url(#paint15_linear_240_33903)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7423 20.8775H26.9276V29.3317H26.7423L24.7407 29.8508L24.7902 20.2397L26.7423 20.8775Z",
    fill: "url(#paint16_linear_240_33903)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5577 20.8223H26.743V29.4062H26.5577L25.7126 29.0354L24.6353 20.8272L26.5577 20.8223Z",
    fill: "url(#paint17_linear_240_33903)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3725 20.7664H26.5578V29.4616H26.3725L24.5884 29.8324L24.796 20.4253L26.3725 20.7664Z",
    fill: "url(#paint18_linear_240_33903)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1861 20.7297H26.3714V29.499H26.1861L24.2142 29.8698L24.2043 20.5171L26.1861 20.7297Z",
    fill: "url(#paint19_linear_240_33903)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8454 0.0390625C21.7471 0.0523637 19.7125 0.335208 17.7748 0.854242L17.9578 1.4446L21.5126 3.66593L23.9821 0.0390625C23.9365 0.0391011 23.8909 0.0390625 23.8454 0.0390625Z",
    fill: "#BEDC7F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7747 0.854492C15.7315 1.40173 13.796 2.21217 12.0063 3.24671L12.3712 3.85909L16.899 5.52771L17.8424 1.07004L17.7747 0.854492Z",
    fill: "#C6E187"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0068 3.24609C10.1796 4.3023 8.50405 5.59199 7.02209 7.07514L7.57286 7.70551L11.3292 7.87409L12.2205 3.79706L12.0068 3.24609Z",
    fill: "#ACD9A3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.02579 7.07227C5.54899 8.54972 4.26387 10.219 3.21094 12.0392L4.37909 12.7756L7.80416 11.8573L7.25397 7.36255L7.02579 7.07227Z",
    fill: "#A0D6CA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.21192 12.0386C2.1732 13.8341 1.36048 15.7764 0.8125 17.8271L2.06346 18.3109L5.39472 16.3868L3.454 12.2136L3.21192 12.0386Z",
    fill: "#A0D6DF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.811972 17.8257C0.28234 19.8074 5.14054e-06 21.8902 5.14054e-06 24.0388C5.14054e-06 24.0481 -6.42568e-06 24.0574 5.14054e-06 24.0667H2.55753L1.63089 18.171L0.811972 17.8257Z",
    fill: "#96C7EA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.38687 24.0645L0 24.0668C0.00244818 26.2125 0.286545 28.2919 0.81718 30.2707L2.21351 30.0557L3.12567 25.061L0.38687 24.0645Z",
    fill: "#8095CB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.990151 30.2129L0.816406 30.2668C1.36767 32.324 2.18582 34.2722 3.23087 36.0721L4.37642 35.4208L4.75114 31.4192L0.990151 30.2129Z",
    fill: "#7578B5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8831 35.3125L3.34894 36.0072L3.22791 36.0674C4.28436 37.8879 5.57303 39.5566 7.05376 41.0332L8.09101 39.9173L7.8831 35.3125Z",
    fill: "#7D68AD"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2127 39.3809L7.26449 40.8177L7.05078 41.0315C8.52875 42.5056 10.1982 43.7879 12.0181 44.8385L12.5602 43.9625L12.2127 39.3809Z",
    fill: "#9B62A8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9759 41.9395L12.1574 44.6092L12.0195 44.8392C13.8169 45.8767 15.7613 46.6878 17.8139 47.2338L18.0427 46.5002L16.9759 41.9395Z",
    fill: "#AF66AB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2455 44.2271L17.965 46.7137L17.8109 47.2328C19.7853 47.7583 21.8598 48.0387 23.9997 48.0387C24.0121 48.0387 24.0244 48.0387 24.0368 48.0387L22.2455 44.2271Z",
    fill: "#BD629A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8581 43.9648L24.0272 47.6357L24.0365 48.039C26.1836 48.0357 28.2646 47.75 30.2444 47.218L30.1587 46.9799L26.8581 43.9648Z",
    fill: "#D97170"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6809 42.4707L30.1079 46.7968L30.2446 47.218C32.2958 46.6668 34.2381 45.8502 36.0332 44.8079L36.0054 44.7424L31.6809 42.4707Z",
    fill: "#E77C57"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9626 39.937L35.9163 44.6183L36.0338 44.8072C37.8506 43.7522 39.5166 42.4663 40.9908 40.9886L40.9439 40.9202L35.9626 39.937Z",
    fill: "#E98163"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9037 35.6543L39.8265 36.9521L40.9871 40.9845L40.9906 40.9886C42.4682 39.5075 43.7534 37.8345 44.8055 36.01L43.9037 35.6543Z",
    fill: "#E98163"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1924 30.2349L44.4061 30.3832L42.9646 33.8577L44.8057 36.0106C45.8391 34.2186 46.6473 32.2803 47.1924 30.2349Z",
    fill: "#EE9F6D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.999 24.0112L45.182 24.8456V28.3681L47.1911 30.2348C47.7178 28.2582 47.999 26.1816 47.999 24.039C47.999 24.0298 47.999 24.0205 47.999 24.0112Z",
    fill: "#F4C270"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1835 17.8101L44.5247 19.0609L45.127 22.6206L47.9995 24.011C47.9971 21.8666 47.7136 19.7879 47.1835 17.8101Z",
    fill: "#F5C976"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7798 12.0234L42.7551 12.8502L43.552 17.5222L47.1833 17.8102C46.6338 15.7599 45.8199 13.8182 44.7798 12.0234Z",
    fill: "#F4E380"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.944 7.0415L39.3085 10.4175L42.9513 12.5803L44.7803 12.0235C43.7217 10.1968 42.4294 8.52227 40.944 7.0415Z",
    fill: "#F0ED81"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9911 3.24512L34.8397 5.93397L39.1115 8.43801L40.9439 7.04231C39.4698 5.57278 37.8053 4.2941 35.9911 3.24568V3.24512Z",
    fill: "#EBF07F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1903 0.845215L29.7942 2.69573L33.1625 5.23916L35.9905 3.24496C34.1914 2.20537 32.2453 1.39222 30.1903 0.845215Z",
    fill: "#E4EF84"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9817 0.0390711L24.277 2.32874L28.4904 3.18735L30.1902 0.844979C28.2154 0.319333 26.1405 0.0390711 24.0002 0.0390711C23.994 0.0390711 23.9879 0.0390518 23.9817 0.0390711Z",
    fill: "#D4E57A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3632 3.26481C15.8658 2.43665 16.6706 1.50406 17.7749 0.854004C18.9795 0.881686 20.1489 1.25017 21.0527 1.72599L21.6458 5.74913L17.5686 6.4907L15.3632 3.26481Z",
    fill: "#B7D458"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2852 6.19418C10.5641 5.21267 11.1808 4.0492 12.0074 3.24512C13.1125 2.99621 14.3591 3.00208 15.3631 3.26488L16.2712 6.6762L13.6766 9.27178L10.2852 6.19418Z",
    fill: "#A3D26D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.13416 10.3658C6.15016 9.41424 6.41737 8.10242 7.0238 7.07409C7.96186 6.57649 9.10047 6.24276 10.2855 6.19434L12.7503 9.82812L10.1558 12.4237L6.13416 10.3658Z",
    fill: "#85CB91"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20694 15.4457C2.95513 14.4624 2.91934 13.169 3.21287 12.0365C3.99119 11.3198 4.98412 10.6932 6.13511 10.3657L9.41541 13.9068L5.70886 16.1316L3.20694 15.4457Z",
    fill: "#7CC8BD"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.68614 21.1375C1.16083 20.0545 0.81346 18.955 0.8125 17.823C1.45912 16.8816 2.08339 16.1581 3.20583 15.4458L6.81971 17.9857L4.96644 21.3229L1.68614 21.1375Z",
    fill: "#77C7D9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.70501 27.0143C0.930417 26.2119 0.247465 25.0666 0 24.0665C0.34498 22.9034 0.947822 21.9179 1.68648 21.1372L4.96678 22.0642L5.70809 25.7722L1.70501 27.0143Z",
    fill: "#6A9ED6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.22508 32.6877C2.26359 32.0836 1.37877 31.2219 0.816406 30.2666C0.848044 29.08 1.22652 27.8305 1.70539 27.0145L5.33781 26.8848L6.07912 31.7051L3.22508 32.6877Z",
    fill: "#5E6CB6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.17211 37.7677C5.04672 37.4429 3.97662 36.7893 3.2291 36.0693C2.91714 34.7536 3.01172 33.5396 3.22543 32.6878L7.74741 32.4468L9.0447 35.7839L6.17211 37.7677Z",
    fill: "#5C51A6"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3232 41.9205C9.23359 41.8897 7.93225 41.5386 7.0511 41.0306C6.45793 39.929 6.20766 38.8877 6.17188 37.7676L9.22977 35.9692L12.751 37.8232L10.3232 41.9205Z",
    fill: "#71459E"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4191 44.8497C14.3758 45.0689 13.2283 45.13 12.0192 44.8391C11.167 43.9158 10.6695 42.9964 10.3226 41.9205L12.3798 38.3794L16.8276 41.3458L15.4191 44.8497Z",
    fill: "#94449B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0903 46.3515C20.1211 46.8708 19.0506 47.2039 17.81 47.2326C16.6914 46.5176 16.0666 45.8297 15.4193 44.8497L16.8278 41.3457L21.6463 43.1997L21.0903 46.3515Z",
    fill: "#AC429A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9646 46.3516C26.1279 47.1415 25.047 47.7647 24.0364 48.0387C22.9329 47.7463 21.8932 47.0936 21.0897 46.3516L22.0164 42.0874L26.2789 43.0144L26.9646 46.3516Z",
    fill: "#BB4574"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6361 44.8315C32.0406 45.8204 31.1337 46.6865 30.2449 47.2183C29.0725 47.2029 27.973 46.8746 26.9651 46.3518L26.4647 42.4584L31.2832 41.7168L32.6361 44.8315Z",
    fill: "#D64C45"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7324 41.8837C37.3659 43.0161 36.8111 43.9956 36.0328 44.809C34.9435 45.0828 33.7747 45.0834 32.6359 44.8315L30.9124 40.9752L35.1749 39.3066L37.7324 41.8837Z",
    fill: "#E2553B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8832 37.7119C41.839 38.9195 41.5078 40.1264 40.9901 40.9888C39.9865 41.5643 38.8049 41.8361 37.7318 41.8833L35.1743 37.8231L39.0662 35.7837L41.8832 37.7119Z",
    fill: "#E45943"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8125 32.6323C45.082 33.7346 45.0603 34.9584 44.8057 36.0104C43.966 36.8267 42.8988 37.4077 41.8843 37.7122L38.6967 34.6716L42.0326 31.3345L44.8125 32.6323Z",
    fill: "#E46844"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3318 26.959C46.8973 28.0803 47.1802 29.1433 47.1922 30.2347C46.5914 31.2085 45.807 31.9791 44.8121 32.6322L41.6615 30.9635L41.8468 27.2556L46.3318 26.959Z",
    fill: "#EB8E4B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3135 21.0815C47.1147 21.9296 47.7093 22.9494 48 24.0108C47.6947 25.1818 47.0209 26.1535 46.3321 26.9587L42.0325 25.7721L42.7738 22.0641L46.3135 21.0815Z",
    fill: "#EFAA4C"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7933 15.4087C45.6203 15.8911 46.7131 16.9363 47.1834 17.8109C47.136 19.1506 46.8167 20.0534 46.3129 21.0819L43.5145 21.3229L42.7732 16.5026L44.7933 15.4087Z",
    fill: "#F4BA53"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8462 10.3101C42.9608 10.6871 43.8869 11.1777 44.7795 12.0238C45.0712 13.2541 45.0111 14.4066 44.7929 15.4084L41.6609 15.9461L39.0663 14.4629L41.8462 10.3101Z",
    fill: "#F0D856"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6964 6.17586C38.7675 6.17007 39.9434 6.49703 40.9446 7.04191C41.5314 8.0752 41.7983 9.2167 41.8477 10.3103L38.3265 11.8676L35.7319 10.0136L37.6964 6.17586Z",
    fill: "#EAE256"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.599 3.22783C33.69 2.98721 34.8466 2.96729 35.9905 3.24463C36.8193 4.14134 37.3804 5.13738 37.6955 6.17562L34.0631 9.45719L31.6538 6.86161L32.599 3.22783Z",
    fill: "#E5EA58"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.91 1.70777C27.8766 1.23415 28.9507 0.885266 30.1898 0.844727C31.2945 1.53722 32.011 2.33402 32.5996 3.22805L30.9131 6.02755L26.9286 5.47135L26.91 1.70777Z",
    fill: "#D9E757"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0532 1.72618C21.5932 1.19417 22.7216 0.38682 23.9814 0.0390625C25.098 0.38628 25.9473 0.876738 26.9096 1.70764L25.5382 5.74932L21.6463 5.56394L21.0532 1.72618Z",
    fill: "#BFD454"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3644 3.26514C14.6122 4.44805 14.2524 5.82335 14.2524 7.19556L15.9945 10.1063L19.6084 8.71584L18.9412 5.23035C17.9408 4.25221 16.7382 3.55851 15.3644 3.26514Z",
    fill: "#93C753"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2116 10.273C9.85634 8.78365 9.88083 7.56332 10.2857 6.19428C11.5547 6.16527 13.0707 6.46764 14.2517 7.19541L16.0865 12.0529L13.4919 13.9068L10.2116 10.273Z",
    fill: "#7DC56C"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.11731 14.3147C6.33584 12.8784 6.09286 11.7308 6.13508 10.3656C7.456 9.91923 9.04712 9.96877 10.2123 10.273L14.0486 14.8338L11.0833 15.9462L7.11731 14.3147Z",
    fill: "#69C191"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66977 18.4493C3.95266 17.578 3.43631 16.5158 3.20569 15.4459C4.25953 14.7719 5.70601 14.3309 7.11609 14.3149L9.41415 15.5756L9.22882 17.4296",
    fill: "#5BBEBD"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.89131 23.6587C2.90468 22.9402 2.23914 22.1271 1.68591 21.1373C2.29698 20.4638 3.12556 19.831 4.03957 19.4316L4.96621 22.8059L3.89131 23.6587Z",
    fill: "#569DC8"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.07666 28.72C2.96277 28.1552 2.39883 27.7324 1.70447 27.0144C2.25377 25.8896 3.27866 24.8526 4.20639 24.252L9.04344 25.4014L8.67278 28.7386L4.59558 29.851L4.07666 28.72Z",
    fill: "#4D73BB"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15416 33.8003C5.84829 33.8061 4.4058 33.4123 3.22522 32.6879C3.37435 31.9261 3.70706 31.2603 3.70706 31.2603L6.44991 30.7783L7.93254 33.5593L7.15416 33.8003Z",
    fill: "#504EA4"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.248 37.8233C8.80264 38.239 7.30753 38.0968 6.17081 37.7676C6.0788 36.1663 6.59783 34.7757 7.15305 33.8001L11.2673 31.1489L13.4912 33.5591L10.248 37.8233Z",
    fill: "#593C9B"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2885 40.9195C13.0774 41.625 11.8401 41.9571 10.3225 41.9206C9.86184 40.3694 9.93063 39.0479 10.2484 37.8234L13.8622 34.3008L16.4568 36.5255L14.2885 40.9195Z",
    fill: "#703296"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9779 42.8661C17.9545 43.8825 16.7767 44.5321 15.4196 44.8499C14.6786 43.6961 14.2804 42.3008 14.2891 40.9195L16.6427 36.7109L19.7933 38.0087L18.9779 42.8661Z",
    fill: "#8C3094"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0373 43.5334C23.4402 44.5245 22.4902 45.6432 21.0906 46.3514C19.957 45.306 19.3666 44.1811 18.9779 42.8659L20.3493 37.6377L23.4999 38.7501L24.0373 43.5334Z",
    fill: "#AA3173"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0771 42.8477C28.7168 44.1216 28.1626 45.2225 26.9643 46.3517C25.6849 45.6749 24.6496 44.6341 24.0362 43.5337L23.8694 38.0088H28.3172L29.0771 42.8477Z",
    fill: "#BF384D"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7668 40.9008C33.7454 42.3872 33.37 43.6828 32.6363 44.8312C31.1405 44.4895 29.9324 43.7411 29.078 42.8475L27.9475 38.0086L31.2834 36.5254L33.7668 40.9008Z",
    fill: "#D73B39"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7887 37.8045C38.1589 39.1382 38.1639 40.5813 37.7331 41.8833C36.2062 41.916 34.9625 41.5772 33.7671 40.9007L31.2837 36.1545L34.6196 33.9297L37.7887 37.8045Z",
    fill: "#E24034"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8833 33.7632C41.6309 35.0668 41.9264 36.3879 41.884 37.7122C40.8019 38.0842 39.2189 38.183 37.7883 37.8049L34.2485 33.93L36.8431 31.3345L40.8833 33.7632Z",
    fill: "#E44E38"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8296 29.0723C43.7824 30.037 44.4742 31.1683 44.8126 32.632C43.7955 33.3685 43.5377 33.5757 40.8836 33.7629L39.6234 33.1882L41.662 28.5532L42.8296 29.0723Z",
    fill: "#E36539"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4782 24.0112C44.7428 24.7552 45.7208 25.7988 46.3323 26.9591C45.4223 27.9046 44.3908 28.602 42.8296 29.0726L39.6234 27.9973L40.1794 24.1039L43.4782 24.0112Z",
    fill: "#E78139"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2558 19.543C45.1238 19.9622 45.6702 20.4031 46.313 21.0818C45.5783 22.3383 44.7563 23.2523 43.4775 24.011H39.9006L40.3639 19.6542L44.2558 19.543Z",
    fill: "#EEA43D"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.847 14.2777C42.4658 14.3037 43.6842 14.6919 44.7945 15.4086C44.7945 15.4086 44.5734 16.2456 44.2393 16.9739L37.203 17.3396L40.2104 13.957L40.847 14.2777Z",
    fill: "#EEB63F"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7501 10.2546C39.1335 9.89759 40.4899 9.90778 41.8459 10.3102C41.8459 11.9164 41.46 13.2828 40.8451 14.2776H40.8081L36.842 11.7748L37.7501 10.2546Z",
    fill: "#E8D141"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7292 7.15869C34.7682 6.54157 36.1478 6.11284 37.6952 6.17611C38.1007 7.72106 38.0755 9.03504 37.7508 10.2549L34.4334 13.5364L31.0975 11.8678L33.7292 7.15869Z",
    fill: "#DFDE43"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0222 5.23033C30.0052 4.32926 30.9143 3.65871 32.599 3.22803C33.3114 4.42901 33.7075 5.67366 33.7295 7.15845L31.2832 11.3114L27.5767 10.199L29.0222 5.23033Z",
    fill: "#D6DF45"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9817 4.56265C24.5856 3.47673 25.4383 2.59791 26.9099 1.70752C27.992 2.72436 28.6842 3.93724 29.0226 5.2301L27.2064 10.755L24.4265 9.45721L23.9817 4.56265Z",
    fill: "#B9D548"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9399 5.23011C19.3418 3.8251 20.0081 2.68746 21.0527 1.72607C22.4721 2.52852 23.3318 3.44473 23.9809 4.56266L23.499 10.1988L19.7925 9.82798L18.9399 5.23011Z",
    fill: "#ACCD47"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0168 9.12333L23.5096 5.5191C23.6323 5.23149 23.7996 4.84583 23.9813 4.5625C24.1689 4.88695 24.3228 5.23506 24.5023 5.65093L25.9458 9.12333L24.7968 12.6088L22.7581 12.0526L22.0168 9.12333Z",
    fill: "#A5C941"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5507 7.69624L18.7753 6.01703C18.8133 5.73987 18.8998 5.35284 18.9398 5.23047C19.1789 5.45933 19.401 5.72741 19.5988 5.98588L22.0163 9.12385L22.2016 12.2385L19.9777 12.6093L18.5507 7.69624Z",
    fill: "#88C045"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8446 12.1269L14.3041 8.10801C14.2813 7.93305 14.2492 7.62475 14.2516 7.19531C14.6416 7.41997 14.9181 7.62299 15.3174 7.91764L16.8399 9.0985L18.2054 10.9509L17.4133 13.8014L14.8446 12.1269Z",
    fill: "#6CBC4F"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0642 14.9079L10.4949 11.1284C10.3521 10.7845 10.2109 10.2729 10.2109 10.2729C10.2109 10.2729 11.1179 10.5445 11.9543 10.9315L14.8441 12.1269L16.0858 14.0921L15.7152 16.3169L12.0642 14.9079Z",
    fill: "#5BB967"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63553 16.3914L7.53432 14.9524C7.2821 14.6049 7.11584 14.3149 7.11584 14.3149C7.11584 14.3149 7.87154 14.3329 8.68084 14.458L12.0641 14.9082L13.5838 15.9464L13.1205 17.3369L8.63553 16.3914Z",
    fill: "#41B68F"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.42984 29.0347L4.95703 29.4931L7.37925 31.2832L10.0415 29.9734L8.96497 28.3652L5.42984 29.0347Z",
    fill: "#504EA4"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21068 26.6992L6.05352 28.3706C5.63337 28.6647 5.20837 29.0909 5.20837 29.0909C5.20837 29.0909 5.49043 29.2152 5.98727 29.2765L9.79969 29.7715L10.7917 30.0098L12.6538 26.9827L8.21068 26.6992Z",
    fill: "#3E4CA4"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0079 28.6646L10.2852 29.5915L10.9894 30.0365L11.1747 28.7387L11.0079 28.6646Z",
    fill: "#3B3594"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0834 33.207L8.19643 33.7273C7.77029 33.7919 7.15369 33.8003 7.15369 33.8003C7.2022 33.6993 7.28342 33.5778 7.28342 33.5778L10.8973 31.3345L12.3799 32.9104L12.0834 33.207Z",
    fill: "#473597"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8632 35.9691L11.0766 37.5526C10.6461 37.7449 10.2485 37.8231 10.2485 37.8231C10.2485 37.8231 10.417 37.2068 10.5726 36.8811L12.0833 33.2067L13.4918 32.4465L16.0864 32.0757L16.457 34.1151L14.8632 35.9691Z",
    fill: "#56258F"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2735 37.9343L14.9659 40.4782C14.7092 40.6683 14.2889 40.9192 14.2889 40.9192C14.2946 40.3528 14.3907 39.6236 14.3907 39.6236L14.8635 35.9691L15.9013 34.6713L19.0519 33.9297L18.2735 37.9343Z",
    fill: "#681D8C"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.054 38.9542L19.6475 42.0989C19.4023 42.4425 18.9776 42.8661 18.9776 42.8661C18.9766 42.8719 18.8196 42.2177 18.7678 41.6864L18.2733 37.9345L18.8664 36.1547L21.6463 34.8569L22.054 38.9542Z",
    fill: "#88226E"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9819 38.9354L24.5218 42.4881C24.4036 42.8195 24.036 43.5333 24.036 43.5333C23.7705 43.0982 23.5528 42.5419 23.5528 42.5419L22.053 38.9539L22.3866 36.7106L24.4252 35.042L25.9819 38.9354Z",
    fill: "#A7264A"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7821 37.9342L29.2987 41.5951C29.2987 41.5951 29.1921 42.4231 29.0779 42.8473C28.7819 42.5829 28.3895 42.0722 28.3895 42.0722L25.9829 38.9354L26.0941 35.4128L28.318 35.042L29.7821 37.9342Z",
    fill: "#BD2539"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1545 35.9507L33.7001 39.9185C33.7518 40.3136 33.766 40.9009 33.766 40.9009C33.4409 40.7159 33.0114 40.4044 33.0114 40.4044L29.7815 37.9345L28.9661 36.062L30.1707 33.5591L33.1545 35.9507Z",
    fill: "#D42832"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9354 33.1696L37.5291 36.9955C37.5291 36.9955 37.7264 37.4902 37.7887 37.8046C37.3281 37.6727 36.7276 37.4292 36.7276 37.4292L33.1555 35.9506L31.2837 33.1882L33.137 30.9634L35.9354 33.1696Z",
    fill: "url(#paint20_linear_240_33903)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9343 33.1699L39.9563 33.7019C40.4109 33.7518 40.8826 33.7632 40.8826 33.7632C40.7647 33.5445 40.5119 33.1699 40.5119 33.1699L39.0664 30.4075L37.3984 28.9243L33.8772 29.8513L34.2479 31.8907L35.9343 33.1699Z",
    fill: "url(#paint21_linear_240_33903)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.884 27.4966L42.259 28.5486C42.599 28.8248 42.83 29.0725 42.83 29.0725L41.936 29.2486L40.4722 29.292L40.3645 27.862L40.884 27.4966Z",
    fill: "#E25831"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8055 22.8403L42.7382 23.6439C43.0531 23.7779 43.4778 24.0113 43.4778 24.0113C43.1451 24.2051 42.6335 24.4337 42.6335 24.4337L40.7644 25.2116L39.9241 24.0688L40.8055 22.8403Z",
    fill: "#E57A31"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9079 13.1668L37.2477 12.7061L36.9845 15.5002L35.1483 15.2071L35.9079 13.1668Z",
    fill: "#EAD041"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1366 12.1083L36.8289 10.5698C37.2589 10.3869 37.7512 10.2544 37.7512 10.2544C37.6385 10.6696 37.4165 11.2414 37.4165 11.2414L36.6913 13.005L35.9165 14.8708L34.0632 15.9461L31.4686 15.5753L33.1366 12.1083Z",
    fill: "#DDCA33"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7455 10.1456L32.9702 7.66125C32.9702 7.66125 33.361 7.36691 33.73 7.16064C33.7223 7.60402 33.6383 8.29844 33.6383 8.29844L33.137 12.1108L31.6544 14.0019L28.5038 13.5383L29.7455 10.1456Z",
    fill: "#CDD035"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9465 9.12385L28.1798 6.22181C28.1798 6.22181 28.7138 5.50497 29.0229 5.23047C29.1355 5.60772 29.2262 6.30595 29.2262 6.30595L29.7457 10.1435L27.9481 12.7947L25.7241 12.2385L25.9465 9.12385Z",
    fill: "#B5CC3B"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2528 15.3158L14.8451 12.127L16.791 12.9242L18.3107 13.7214L17.5694 16.1315L15.2528 15.3158Z",
    fill: "#4EB150"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2526 15.3156L12.0649 14.9077L12.8618 16.8173L13.6773 18.3561L16.0866 17.7999L15.2526 15.3156Z",
    fill: "#3EAF68"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2894 32.7806L14.8632 35.9694L17.8469 34.7458L18.6809 33.3739L16.8276 31.3345L15.2894 32.7806Z",
    fill: "#551F8B"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8475 34.7458L18.2738 37.9346L20.8313 35.988L21.2761 34.1155L19.2375 33.1885L17.8475 34.7458Z",
    fill: "url(#paint22_linear_240_33903)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5327 32.4837L17.8478 34.7456L19.942 33.8556L20.257 32.5393L19.1451 31.6123L17.5327 32.4837Z",
    fill: "url(#paint23_linear_240_33903)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0182 36.3957L22.0537 38.9542L20.8306 35.9878L21.4607 33.5591L23.8699 34.4861L24.0182 36.3957Z",
    fill: "#92284A"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1521 13.332L33.1359 12.1084L32.7281 15.2973L31.0973 16.4096L29.522 15.8534L30.1521 13.332Z",
    fill: "#CAC13A"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1879 12.1088L29.7454 10.1436L30.1532 13.3324L29.1615 15.1595L26.6733 14.5731L27.1879 12.1088Z",
    fill: "#B0C03D"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9817 11.682L25.9462 9.12354L27.1878 12.1084L26.5577 14.0922L24.0558 13.7214L23.9817 11.682Z",
    fill: "#A0C142"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9814 11.682L22.0169 9.12354L20.7577 12.2811L21.0986 13.2684L22.9109 13.8727L23.9814 11.682Z",
    fill: "#80BD46"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.917 14.871L36.6213 14.7783L37.3997 15.3901L36.751 17.0587L34.7124 16.7806L35.917 14.871Z",
    fill: "#E5B032"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7292 15.297L35.9169 14.8706L35.2158 16.5397L33.9301 18.1728L32.23 17.6313L32.2173 15.9262L32.7292 15.297Z",
    fill: "url(#paint24_linear_240_33903)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4137 17.5591L33.8407 17.7445L34.5264 18.1709L33.9704 20.3957L31.6538 19.376L32.4137 17.5591Z",
    fill: "#D3A339"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4678 15.594L32.7288 15.2974L32.4138 17.5592L31.3759 18.3564L29.8007 17.5221L30.4678 15.594Z",
    fill: "url(#paint25_linear_240_33903)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0585 14.2219L30.1527 13.332L30.4678 15.5939L29.8006 16.5023L27.5767 16.3169L28.0585 14.2219Z",
    fill: "#B1BA3F"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3713 13.4989L27.1875 12.1084L28.0586 14.222L27.5767 15.39L25.3528 15.2972L25.3713 13.4989Z",
    fill: "url(#paint26_linear_240_33903)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6093 13.499L23.9807 11.6821L25.3706 13.499L24.8888 15.112L23.4988 15.3901L22.6093 13.499Z",
    fill: "#7AB749"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9999 14.8525C24.7902 13.9415 25.3713 13.499 25.3713 13.499C25.9252 14.1628 26.3721 15.1676 26.3721 15.1676L25.3528 16.6879H24.1481L23.9999 14.8525Z",
    fill: "url(#paint27_linear_240_33903)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6104 13.499L20.961 12.2383L20.6274 15.112L22.0174 15.6682L22.6104 13.499Z",
    fill: "#5FB34E"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6098 13.499C22.0889 14.148 21.4608 15.2974 21.4608 15.2974L22.4801 16.5952L23.2214 16.6879L23.9998 14.8525C23.5723 14.3464 23.1063 13.8723 22.6098 13.499Z",
    fill: "#64B24E"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5675 17.5778L15.2524 15.3159L16.7907 15.5198L17.7544 16.1317L17.0131 18.2638L15.5675 17.5778Z",
    fill: "#39A757"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1223 17.763L15.5679 17.5776L16.2721 18.3563L16.8281 20.0249L13.4922 20.2103L14.1223 17.763Z",
    fill: "#349169"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0496 19.4686C15.8653 18.9985 15.6823 18.3957 15.5677 17.5776C15.5677 17.5776 16.1866 17.5034 16.7909 17.5034L17.6619 18.5417L16.7353 19.8394L16.0496 19.4686Z",
    fill: "#328D5E"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.11003 22.2857L8.10156 22.9796L10.6391 23.3985L10.0809 20.9995L8.11003 22.2857Z",
    fill: "#3E70AC"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09967 22.1015L8.20315 22.4803L7.2135 22.5014L7.63643 20.1152L9.09967 22.1015Z",
    fill: "#569DC8"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.10048 22.1015L7.62244 20.9677L8.06016 19.0913L12.4332 19.7683L12.687 21.596L9.10048 22.1015Z",
    fill: "#449AAD"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0839 20.8594L9.1001 22.1016L10.6013 23.2325L10.9904 24.1966L12.8437 24.0111L14.141 22.3426L12.0839 20.8594Z",
    fill: "#377097"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4549 22.6575L12.0835 20.8591L12.7491 20.5726L14.1777 19.9878L15.9012 21.1373L15.3453 22.8058L13.4549 22.6575Z",
    fill: "#317178"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4552 22.6577L12.0586 23.7484L13.9097 25.337L15.3632 24.0805L13.4552 22.6577Z",
    fill: "#345387"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4556 22.6579C13.8701 23.1984 14.3936 23.6926 14.8085 24.0484L16.6432 23.9186L17.1992 22.4354L15.142 21.6753C14.4698 21.9562 14.0318 22.2443 13.4556 22.6579Z",
    fill: "url(#paint28_linear_240_33903)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1408 21.675C14.8092 21.1978 14.4072 20.6287 14.1771 19.9879C14.7741 19.7247 15.431 19.5526 16.0489 19.4688L17.5686 20.2104L17.3833 21.6936L15.1408 21.675Z",
    fill: "#327269"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0493 19.4687C16.0493 19.4687 16.4691 19.4042 16.7906 19.3945L17.291 20.0249L16.8138 20.94C16.8138 20.94 16.3662 20.2161 16.0493 19.4687Z",
    fill: "#337762"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5863 23.136C16.5863 23.136 15.5908 22.3224 15.1421 21.6751C15.7317 21.3846 16.8485 21.1729 16.8485 21.1729L17.6056 23.0894L16.5863 23.136Z",
    fill: "url(#paint29_linear_240_33903)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8071 24.0479C15.4575 23.5574 16.1235 23.2158 16.7964 22.939L17.7353 24.608L16.327 25.4288L14.8552 24.9042L14.8071 24.0479Z",
    fill: "url(#paint30_linear_240_33903)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8953 24.9174C13.8953 24.9174 14.2591 24.4687 14.8074 24.0483C15.6434 24.7758 16.4583 25.1839 16.4583 25.1839L15.6124 27.4686L13.557 27.2655L13.8953 24.9174Z",
    fill: "url(#paint31_linear_240_33903)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2897 32.7805L12.0835 33.2069L12.2503 32.8175L14.8634 26.8751C15.4229 25.7966 16.8351 24.7734 16.8351 24.7734L17.7106 27.2062L15.2897 32.7805Z",
    fill: "url(#paint32_linear_240_33903)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5314 32.4839L15.2889 32.7806C15.5648 30.0856 16.9232 25.8696 16.9232 25.8696L19.196 30.0341L17.5314 32.4839Z",
    fill: "url(#paint33_linear_240_33903)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4221 32.076C19.4221 32.076 18.2726 32.3683 17.5318 32.4839C17.3905 31.1141 17.4683 30.2375 17.8537 28.9019L21.1106 31.8602L20.0279 32.4018L19.4221 32.076Z",
    fill: "url(#paint34_linear_240_33903)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9407 33.8554C19.6126 33.0433 19.4218 32.0756 19.4218 32.0756L20.4341 31.7808L22.4139 33.115L20.2188 33.9886L19.9407 33.8554Z",
    fill: "url(#paint35_linear_240_33903)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9314 32.9187L19.9413 33.8556L20.8309 35.9877L22.6285 34.5973L23.8702 34.6714L24.6115 32.2612L21.9314 32.9187Z",
    fill: "#782E58"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.041 33.4059L22.6288 34.5972L24.0187 36.3956L25.3531 36.5253L27.3917 32.8174L24.041 33.4059Z",
    fill: "url(#paint36_linear_240_33903)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1343 33.5972L24.0181 36.3959L25.9825 38.9358L27.2057 35.9694L28.6883 35.4132L29.059 31.3345L26.1343 33.5972Z",
    fill: "#AB273D"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.395 33.0855L27.2056 35.9694L29.7816 37.9346L30.1893 34.7272L31.2828 33.5592L30.9121 30.5928L28.395 33.0855Z",
    fill: "#C22636"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5548 31.8649L30.1899 34.7271L33.1552 35.9508L32.7475 32.7805L33.5073 31.3343L32.0247 28.7388L30.5548 31.8649Z",
    fill: "url(#paint37_linear_240_33903)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3853 29.5791L32.7477 32.7803L35.9353 33.1697L34.6936 30.2033L35.3608 27.9971L33.1369 26.1431L32.3853 29.5791Z",
    fill: "url(#paint38_linear_240_33903)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4558 27.1378L34.6936 30.2032L37.2389 29.8632L37.6186 27.5925L33.384 23.835L33.4558 27.1378Z",
    fill: "url(#paint39_linear_240_33903)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8796 24.5768L36.8282 28.3762L37.2948 23.9426L32.6415 21.1782L32.6116 23.6553L33.8796 24.5768Z",
    fill: "url(#paint40_linear_240_33903)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9941 20.4678L36.6999 20.4634L36.7761 21.2951L35.7085 21.1126L35.9941 20.4678Z",
    fill: "#E79F36"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9349 20.8222L36.1888 20.4934L35.3171 20.3184L34.9478 20.7163L35.5175 20.9467L35.9349 20.8222Z",
    fill: "#DF9A36"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5272 22.6391L36.686 24.2839L36.8116 21.2324L36.6307 21.1202L35.9357 20.8223L34.5272 21.2301V22.6391Z",
    fill: "#E08535"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0249 19.45C32.0249 19.45 33.184 19.6781 33.8411 19.9692L35.2495 20.5439L35.9353 20.822L34.5268 22.6389C34.0176 22.2219 33.1149 21.7587 33.1149 21.7587L31.2069 19.4551L31.817 19.0303L32.0249 19.45Z",
    fill: "url(#paint41_linear_240_33903)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5005 17.5154C31.2694 17.4721 31.728 17.4799 32.4145 17.5593C32.299 18.1893 32.1725 18.8203 32.0253 19.4504L31.4346 19.3597L30.0051 18.3544L30.5005 17.5154Z",
    fill: "url(#paint42_linear_240_33903)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6504 16.0387C29.3496 15.7894 29.9112 15.6883 30.4667 15.5938C30.5645 16.4831 30.5595 17.5054 30.5408 18.3562L26.8342 16.7803L28.3169 15.946L28.6504 16.0387Z",
    fill: "url(#paint43_linear_240_33903)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3723 15.1677C26.3723 15.1677 27.2264 14.5249 28.0588 14.2222C28.3434 14.8913 28.6518 16.039 28.6518 16.039L27.2248 16.7621L26.465 16.966L26.3723 15.1677Z",
    fill: "url(#paint44_linear_240_33903)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3719 15.1675C25.7968 15.6477 25.2434 16.1203 24.8022 16.6675L24.8007 16.9362L26.9181 16.9835C26.9181 16.9835 26.6745 15.8832 26.3719 15.1675Z",
    fill: "url(#paint45_linear_240_33903)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 14.8525C24.438 15.3434 25.0223 16.5774 25.0223 16.5774L24.5409 17.0591L23.1848 17.1887L22.8632 16.7419C22.8632 16.7419 23.3357 15.5943 24.0001 14.8525Z",
    fill: "url(#paint46_linear_240_33903)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0022 20.6926H26.1875V29.536H26.0022L24.742 29.6696L24.4751 20.2822L26.0022 20.6926Z",
    fill: "url(#paint47_linear_240_33903)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8165 20.6737H26.0018V29.5543H25.8165L23.8149 29.8064V20.2139L25.8165 20.6737Z",
    fill: "url(#paint48_linear_240_33903)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.63 20.6553H25.8153V29.5915H25.63L23.3813 29.9227L23.4209 22.1138L25.63 20.6553Z",
    fill: "url(#paint49_linear_240_33903)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4452 20.6367H25.6305V29.5914H25.4452L22.811 29.6656L25.1239 21.2251L25.4452 20.6367Z",
    fill: "url(#paint50_linear_240_33903)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2603 20.6368H25.4456V29.6101H25.2603L22.8436 29.7448L22.8832 20.1572L25.2603 20.6368Z",
    fill: "url(#paint51_linear_240_33903)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0742 20.6369H25.2596V29.6102H25.0742L23.2704 29.9315L23.2407 20.5034L25.0742 20.6369Z",
    fill: "url(#paint52_linear_240_33903)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8898 20.6368H25.0751V29.6101H24.8898L23.2145 30.0995L23.1848 20.0386L24.8898 20.6368Z",
    fill: "url(#paint53_linear_240_33903)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7042 20.637H24.8896V29.6102H24.7042L22.8905 29.9414L22.9103 20.0684L24.7042 20.637Z",
    fill: "url(#paint54_linear_240_33903)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5187 20.6553H24.704V29.5915H24.5187L23.0904 30.0415L23.0311 20.4526L24.5187 20.6553Z",
    fill: "url(#paint55_linear_240_33903)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3342 20.6555H24.5195V29.5917H24.3342L23.0641 29.9822L22.9751 20.5615L24.3342 20.6555Z",
    fill: "url(#paint56_linear_240_33903)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1471 20.6738H24.3324V29.5729H24.1471L22.9264 29.9338L22.8967 20.5601L24.1471 20.6738Z",
    fill: "url(#paint57_linear_240_33903)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9636 20.7667H24.1489V29.4804H23.9636L23.0394 29.5842L22.9702 20.4058L23.9636 20.7667Z",
    fill: "url(#paint58_linear_240_33903)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7786 20.8034H23.964V29.443H23.7786L22.7358 29.4973L22.7655 20.5513L23.7786 20.8034Z",
    fill: "url(#paint59_linear_240_33903)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5913 20.8594H23.7767V29.3877H23.5913L22.7957 29.4421L22.7759 21.0028L23.5913 20.8594Z",
    fill: "url(#paint60_linear_240_33903)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4068 20.9336H23.5922V29.3136H23.4068L21.1483 28.4682L21.1582 20.9385L23.4068 20.9336Z",
    fill: "url(#paint61_linear_240_33903)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2217 21.0073H23.407V29.239H23.2217L21.3684 29.1945V21.0518L23.2217 21.0073Z",
    fill: "url(#paint62_linear_240_33903)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0362 21.0815H23.2215V29.1463H23.0362L20.9556 29.2106L20.7382 21.0073L23.0362 21.0815Z",
    fill: "url(#paint63_linear_240_33903)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8511 21.1743H23.0365V29.0537H22.8511L20.8891 29.0389L20.8397 21.5154L22.8511 21.1743Z",
    fill: "url(#paint64_linear_240_33903)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6652 21.2858H22.8506V28.9427H22.6652L20.6835 28.8785L20.812 21.2314L22.6652 21.2858Z",
    fill: "url(#paint65_linear_240_33903)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4795 21.4156H22.6649V28.813H22.4795L20.8733 28.7981L20.7053 21.3315L22.4795 21.4156Z",
    fill: "url(#paint66_linear_240_33903)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2947 21.5454H22.4801V28.6647H22.2947L20.649 28.6202L20.5897 21.5899L22.2947 21.5454Z",
    fill: "url(#paint67_linear_240_33903)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2946 21.6934H22.1092L20.5821 21.8762L20.5129 28.2948L22.1092 28.4975H22.2946V21.6934Z",
    fill: "url(#paint68_linear_240_33903)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1096 21.8789H21.9242L20.5454 21.9531L20.6047 28.2863L21.9242 28.3307H22.1096V21.8789Z",
    fill: "url(#paint69_linear_240_33903)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9242 22.0645V28.127H21.7389L19.9153 28.1418L19.935 22.1486L21.7389 22.0645H21.9242Z",
    fill: "url(#paint70_linear_240_33903)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7392 27.886H21.5539L20.1157 27.9403L20.1454 21.8667L21.5539 22.287H21.7392V27.886Z",
    fill: "url(#paint71_linear_240_33903)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1874 27.6226L21.3685 27.6078H21.5539V22.5279H21.3685L20.3455 22.4438L20.1874 27.6226Z",
    fill: "url(#paint72_linear_240_33903)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3689 27.2741H21.1836L19.9036 27.3878L19.9727 22.5601L21.1836 22.8616H21.3689V27.2741Z",
    fill: "url(#paint73_linear_240_33903)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9973 23.2323H21.1826V26.9031H20.9973L19.7173 26.8883L19.7865 23.168L20.9973 23.2323Z",
    fill: "url(#paint74_linear_240_33903)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8124 23.7329H20.9977V26.3656H20.8124L19.2655 24.7686L20.8124 23.7329Z",
    fill: "url(#paint75_linear_240_33903)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9798 14.7412C22.6612 15.6665 23.2774 17.1038 23.2774 17.1038L20.4839 19.057L20.2577 14.9145L20.9798 14.7412Z",
    fill: "url(#paint76_linear_240_33903)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70717 29.128C3.70717 28.8565 3.87732 28.7124 4.10507 28.7124C4.25025 28.7124 4.37528 28.7659 4.48555 28.8128C5.88166 29.3518 7.25397 29.8624 8.88172 29.8586C10.0316 29.8586 11.0135 29.455 11.0135 28.4293C11.0135 27.8687 10.8222 27.6733 10.5828 27.5521C10.3202 27.4073 10.0246 27.272 9.72214 27.1594C8.92997 26.8643 8.15651 26.7348 7.33959 26.4212C6.56188 26.1268 5.58291 25.7146 4.86062 25.0307C3.97518 24.2195 3.52087 23.1235 3.52087 21.7258C3.52087 18.3827 6.25901 16.3149 9.66703 16.3149C11.9242 16.3149 13.7705 17.0215 13.7705 17.0215C13.946 17.0812 14.1226 17.1391 14.1226 17.3367V20.5626C14.1226 20.8058 14.0097 20.9881 13.7963 20.9881C13.6721 20.9881 13.4183 20.8778 13.4183 20.8778C13.4183 20.8778 11.3005 20.0589 9.85103 20.0749C8.21916 20.0749 7.58028 20.7828 7.58028 21.5588C7.58028 22.2751 8.26259 22.4654 9.17461 22.7547C9.61235 22.8747 11.3824 23.3298 12.1766 23.6958C13.9486 24.4076 15.0785 26.0548 15.0785 28.1292C15.0785 31.1885 12.8302 33.6988 8.75665 33.6988C7.09552 33.6988 5.99574 33.4617 4.02224 32.7803C3.84447 32.724 3.70717 32.6509 3.70717 32.4281V29.128Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6117 20.5443H34.1746C33.9963 20.5443 33.8411 20.4406 33.8411 20.2106V16.7436C33.8411 16.573 33.9756 16.4377 34.1376 16.4377H36.6117V11.571C36.6117 11.37 36.7329 11.2373 36.9546 11.2373H40.4943C40.7002 11.2373 40.8279 11.3771 40.8279 11.571V16.4377H43.8858C44.1147 16.4377 44.2565 16.557 44.2565 16.7993V20.192C44.2565 20.4149 44.1118 20.5443 43.9043 20.5443H40.8279V26.4728C40.8279 27.0362 40.8494 28.2655 41.5053 28.8992C42.0432 29.4248 43.0573 29.5361 43.9229 29.5361C44.109 29.5361 44.2565 29.6701 44.2565 29.8698V33.2997C44.2565 33.4827 44.1469 33.6427 43.9155 33.6427H43.3965C40.6812 33.6427 39.1847 32.6744 38.3198 31.8013C37.1285 30.572 36.6117 29.0676 36.6117 26.5882V20.5443Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M17.104 7.64209C16.9117 7.64209 16.7889 7.77995 16.7889 7.95732V24.2185C16.7889 27.7639 17.5264 29.3216 18.8131 30.7908C20.6254 32.8601 23.181 33.6929 25.263 33.6929C30.1924 33.6929 33.941 29.6792 33.941 25.1176C33.941 20.4732 30.0925 16.5401 25.5387 16.5401C22.8411 16.5401 21.0051 18.0429 21.0051 18.0429V7.95732C21.0051 7.75799 20.8487 7.64209 20.6901 7.64209H17.104ZM25.2347 20.6478C27.7174 20.6478 29.7161 22.5079 29.7161 25.131C29.7161 27.8088 27.5734 29.5944 25.1831 29.5944C22.5202 29.5944 20.8111 27.3865 20.8111 24.9942C20.8111 22.8864 22.4302 20.6478 25.2347 20.6478Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_240_33903",
    x1: 27.3919,
    y1: 21.3226,
    x2: 27.3919,
    y2: 28.9239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C7E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0236077,
    stopColor: "#9F793D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0477371,
    stopColor: "#A0773C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0849093,
    stopColor: "#A3733D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122408,
    stopColor: "#A26F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159254,
    stopColor: "#A66A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194796,
    stopColor: "#A8653A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231642,
    stopColor: "#AA6139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267836,
    stopColor: "#AC5B38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305661,
    stopColor: "#AE5839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341203,
    stopColor: "#AF5337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377071,
    stopColor: "#B24F37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414569,
    stopColor: "#B34B38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451415,
    stopColor: "#B34736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487283,
    stopColor: "#B54437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523803,
    stopColor: "#B53F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56065,
    stopColor: "#B43C36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597496,
    stopColor: "#B43735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633364,
    stopColor: "#B43536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671188,
    stopColor: "#B53336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707708,
    stopColor: "#B43236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743902,
    stopColor: "#B33136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.780097,
    stopColor: "#B43036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816617,
    stopColor: "#B32F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852811,
    stopColor: "#B22E35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889331,
    stopColor: "#B12E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.926503,
    stopColor: "#B12C36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963023,
    stopColor: "#B12C36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B12D39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_240_33903",
    x1: 29.6149,
    y1: 24.2891,
    x2: 29.6149,
    y2: 26.0504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C65233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.104673,
    stopColor: "#C94D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205901,
    stopColor: "#C94C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36469,
    stopColor: "#C84932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526316,
    stopColor: "#CD4634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688223,
    stopColor: "#CC4334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841057,
    stopColor: "#CC3E34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3D34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_240_33903",
    x1: 29.4307,
    y1: 23.6403,
    x2: 29.4307,
    y2: 26.6067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C35C35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06125,
    stopColor: "#C45633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155417,
    stopColor: "#C65335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C64E34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342917,
    stopColor: "#C94C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437642,
    stopColor: "#C94834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529566,
    stopColor: "#CA4534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625025,
    stopColor: "#CA4133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719306,
    stopColor: "#C93E33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81123,
    stopColor: "#CC3C35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905511,
    stopColor: "#CA3A35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB3832"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_240_33903",
    x1: 29.2448,
    y1: 23.177,
    x2: 29.2448,
    y2: 27.0704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C15F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069978,
    stopColor: "#C25C35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142709,
    stopColor: "#C25835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214542,
    stopColor: "#C55435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286375,
    stopColor: "#C55035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356412,
    stopColor: "#C64C35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427347,
    stopColor: "#C74835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500078,
    stopColor: "#C94534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571912,
    stopColor: "#C84233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641949,
    stopColor: "#C93E33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713782,
    stopColor: "#CA3C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785615,
    stopColor: "#C93934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857448,
    stopColor: "#CB3834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925689,
    stopColor: "#C93634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C93535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_240_33903",
    x1: 29.0591,
    y1: 22.8987,
    x2: 29.0591,
    y2: 27.3482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0630556,
    stopColor: "#BF5F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.123611,
    stopColor: "#C15B36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186944,
    stopColor: "#C25836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249722,
    stopColor: "#C35436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#C44F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374722,
    stopColor: "#C54D35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436944,
    stopColor: "#C64635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499722,
    stopColor: "#C64534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561389,
    stopColor: "#C74134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624167,
    stopColor: "#C83F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686944,
    stopColor: "#C83B33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749167,
    stopColor: "#C83934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CA3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874722,
    stopColor: "#C73534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938611,
    stopColor: "#C83434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C73534"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_240_33903",
    x1: 28.8737,
    y1: 22.7131,
    x2: 28.8737,
    y2: 27.5334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B96637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.038083,
    stopColor: "#BB6337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0772375,
    stopColor: "#BD6037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133794,
    stopColor: "#BF5C36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191076,
    stopColor: "#BF5935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249083,
    stopColor: "#C15435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308539,
    stopColor: "#C25035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363646,
    stopColor: "#C24D35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424553,
    stopColor: "#C34934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481835,
    stopColor: "#C54534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539116,
    stopColor: "#C54034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597123,
    stopColor: "#C83F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652229,
    stopColor: "#C73C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711686,
    stopColor: "#C73A35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769693,
    stopColor: "#C73734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825525,
    stopColor: "#C63535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884982,
    stopColor: "#C63434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942988,
    stopColor: "#C53333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C52F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_240_33903",
    x1: 28.6883,
    y1: 22.528,
    x2: 28.6883,
    y2: 27.6264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B76838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0353464,
    stopColor: "#B86637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0723731,
    stopColor: "#B86337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127227,
    stopColor: "#BC5F37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182082,
    stopColor: "#BD5A37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23625,
    stopColor: "#BE5635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29179,
    stopColor: "#C05334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344588,
    stopColor: "#C14D35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401499,
    stopColor: "#C34B34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454296,
    stopColor: "#C34734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508465,
    stopColor: "#C44234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56332,
    stopColor: "#C54034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61886,
    stopColor: "#C43D34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671657,
    stopColor: "#C53934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726511,
    stopColor: "#C53734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783423,
    stopColor: "#C43635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835534,
    stopColor: "#C53434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890389,
    stopColor: "#C43335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945243,
    stopColor: "#C43134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C43036"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_240_33903",
    x1: 28.5038,
    y1: 22.2497,
    x2: 28.5038,
    y2: 27.9044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B36E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.030973,
    stopColor: "#B56A38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0662124,
    stopColor: "#B66739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115671,
    stopColor: "#B86238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163894,
    stopColor: "#BA6037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.213971,
    stopColor: "#BB5A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261575,
    stopColor: "#BC5736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311652,
    stopColor: "#BE5336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.360492,
    stopColor: "#C04E35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409951,
    stopColor: "#C14B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457555,
    stopColor: "#C04734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508869,
    stopColor: "#C24335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556473,
    stopColor: "#C24035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605932,
    stopColor: "#C33C35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655391,
    stopColor: "#C43A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70485,
    stopColor: "#C33733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754308,
    stopColor: "#C33534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802531,
    stopColor: "#C23435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853226,
    stopColor: "#C13334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901448,
    stopColor: "#C23135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.950289,
    stopColor: "#C23135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C12F35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_240_33903",
    x1: 28.3186,
    y1: 22.0642,
    x2: 28.3186,
    y2: 28.0896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B06F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459116,
    stopColor: "#B16B39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0766617,
    stopColor: "#B46839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.123077,
    stopColor: "#B56438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168332,
    stopColor: "#B66038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215907,
    stopColor: "#B95C36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.260002,
    stopColor: "#BB5736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307577,
    stopColor: "#BC5336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354573,
    stopColor: "#BD4F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.400988,
    stopColor: "#BE4C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446823,
    stopColor: "#BD4836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492658,
    stopColor: "#C14236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538493,
    stopColor: "#C03F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583748,
    stopColor: "#C23D35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630163,
    stopColor: "#C03A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677159,
    stopColor: "#C03833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721833,
    stopColor: "#C03533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770569,
    stopColor: "#C13435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816404,
    stopColor: "#C13236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861659,
    stopColor: "#C03135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906914,
    stopColor: "#C03135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952749,
    stopColor: "#BF3035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE2F35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_240_33903",
    x1: 28.1332,
    y1: 21.8791,
    x2: 28.1332,
    y2: 28.2754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC743A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0420378,
    stopColor: "#AE6E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0874625,
    stopColor: "#B06A39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129604,
    stopColor: "#B36739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173934,
    stopColor: "#B46138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216622,
    stopColor: "#B65D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.260952,
    stopColor: "#B75938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304188,
    stopColor: "#BA5436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347423,
    stopColor: "#BB5037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393395,
    stopColor: "#BB4D36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434989,
    stopColor: "#BC4936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479319,
    stopColor: "#BE4336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522007,
    stopColor: "#BD4035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564148,
    stopColor: "#BF3E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607931,
    stopColor: "#BF3C35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652809,
    stopColor: "#BF3935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696044,
    stopColor: "#BE3635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738733,
    stopColor: "#BE3635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781968,
    stopColor: "#BF3235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826845,
    stopColor: "#BE3135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868439,
    stopColor: "#BE3036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.912222,
    stopColor: "#BD2F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956005,
    stopColor: "#BD2F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC2E36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_240_33903",
    x1: 27.9477,
    y1: 21.6936,
    x2: 27.9477,
    y2: 28.4606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9773C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0275801,
    stopColor: "#A9743B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0553798,
    stopColor: "#AB703A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0952503,
    stopColor: "#AD6B39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136218,
    stopColor: "#AF6738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177552,
    stopColor: "#B26338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219251,
    stopColor: "#B25F38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258756,
    stopColor: "#B55A38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300821,
    stopColor: "#B65637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342155,
    stopColor: "#B85237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383123,
    stopColor: "#B94E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423359,
    stopColor: "#BA4A35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466156,
    stopColor: "#BB4635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506392,
    stopColor: "#BC4135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546628,
    stopColor: "#BB3E35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589791,
    stopColor: "#BD3B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63149,
    stopColor: "#BD3936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671361,
    stopColor: "#BD3635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71306,
    stopColor: "#BC3535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753297,
    stopColor: "#BC3335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794264,
    stopColor: "#BB3234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835232,
    stopColor: "#BD3136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876566,
    stopColor: "#BC3035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "#BB2F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959233,
    stopColor: "#BB2F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B92F36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_240_33903",
    x1: 27.7625,
    y1: 21.601,
    x2: 27.7625,
    y2: 28.5535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4783B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0383979,
    stopColor: "#A6753B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0796974,
    stopColor: "#A96E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.120641,
    stopColor: "#AC6A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160872,
    stopColor: "#AD663A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.200036,
    stopColor: "#AF6238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239199,
    stopColor: "#B15E38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.280498,
    stopColor: "#B35938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.319306,
    stopColor: "#B45437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359537,
    stopColor: "#B65136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399769,
    stopColor: "#B84C38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441068,
    stopColor: "#B84936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478807,
    stopColor: "#B94536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519395,
    stopColor: "#B94035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559626,
    stopColor: "#B93D35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.599858,
    stopColor: "#B83A35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639733,
    stopColor: "#BA3836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679964,
    stopColor: "#B93535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719484,
    stopColor: "#B83434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760071,
    stopColor: "#B93135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799235,
    stopColor: "#BB3035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839466,
    stopColor: "#B83036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880053,
    stopColor: "#B72F37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919217,
    stopColor: "#B92F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96016,
    stopColor: "#B82E35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B72F37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_240_33903",
    x1: 27.5767,
    y1: 21.4155,
    x2: 27.5767,
    y2: 28.7388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A17B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0247398,
    stopColor: "#A2793C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0515441,
    stopColor: "#A3763D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0884,
    stopColor: "#A5723B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.126692,
    stopColor: "#A86D3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165462,
    stopColor: "#AA683A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201361,
    stopColor: "#AC633A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.240131,
    stopColor: "#AF5F38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276987,
    stopColor: "#B05B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316456,
    stopColor: "#B25637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35405,
    stopColor: "#B35237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392342,
    stopColor: "#B44D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429676,
    stopColor: "#B64A37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468447,
    stopColor: "#B74637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506738,
    stopColor: "#B64236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544073,
    stopColor: "#B63D36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582843,
    stopColor: "#B73B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.620657,
    stopColor: "#B63836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657513,
    stopColor: "#B73635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69724,
    stopColor: "#B73436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733139,
    stopColor: "#B73237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772152,
    stopColor: "#B63136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.810201,
    stopColor: "#B52F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848014,
    stopColor: "#B52F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885828,
    stopColor: "#B62D36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924598,
    stopColor: "#B42E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961933,
    stopColor: "#B42E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B32D36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_240_33903",
    x1: 27.3918,
    y1: 21.3228,
    x2: 27.3918,
    y2: 28.9241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C7E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0239337,
    stopColor: "#9F793D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0480631,
    stopColor: "#A0773C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0849093,
    stopColor: "#A3733D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122408,
    stopColor: "#A26F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15795,
    stopColor: "#A66A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195122,
    stopColor: "#A8653A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231968,
    stopColor: "#AA6139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26751,
    stopColor: "#AD5C39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305008,
    stopColor: "#AE5839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341855,
    stopColor: "#AF5337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377397,
    stopColor: "#B24F37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414243,
    stopColor: "#B34B38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.452393,
    stopColor: "#B34736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487935,
    stopColor: "#B54437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524455,
    stopColor: "#B53F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561302,
    stopColor: "#B43C36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598148,
    stopColor: "#B43735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634016,
    stopColor: "#B43536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672166,
    stopColor: "#B53336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708034,
    stopColor: "#B43237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74325,
    stopColor: "#B33136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.780097,
    stopColor: "#B43036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816943,
    stopColor: "#B32F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853137,
    stopColor: "#B22E35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889983,
    stopColor: "#B22D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927155,
    stopColor: "#B12C36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962697,
    stopColor: "#B12C36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B12D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_240_33903",
    x1: 27.2064,
    y1: 21.2298,
    x2: 27.2064,
    y2: 29.0165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A7F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.034632,
    stopColor: "#9C7A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0715559,
    stopColor: "#9E783E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106888,
    stopColor: "#9F723B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.143175,
    stopColor: "#A16C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178826,
    stopColor: "#A5693A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214477,
    stopColor: "#A7643A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249809,
    stopColor: "#A9603A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286096,
    stopColor: "#AC5B3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32111,
    stopColor: "#AC5737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357079,
    stopColor: "#AD5239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392093,
    stopColor: "#AF4D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428062,
    stopColor: "#B14B39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464349,
    stopColor: "#B14636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500318,
    stopColor: "#B04336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535969,
    stopColor: "#B23F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570665,
    stopColor: "#B23C36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608225,
    stopColor: "#B23836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643557,
    stopColor: "#B13536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678253,
    stopColor: "#B23536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712949,
    stopColor: "#B13236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749554,
    stopColor: "#B13137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785842,
    stopColor: "#B13036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821811,
    stopColor: "#B02F37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857143,
    stopColor: "#B02F37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892475,
    stopColor: "#AF2E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928444,
    stopColor: "#B12E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96505,
    stopColor: "#B12E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B12D39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_240_33903",
    x1: 27.0213,
    y1: 21.1372,
    x2: 27.0213,
    y2: 29.1093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#977F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0224475,
    stopColor: "#987E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.057269,
    stopColor: "#98793D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0933342,
    stopColor: "#9D753E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127845,
    stopColor: "#9E713C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.162666,
    stopColor: "#9F6C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198421,
    stopColor: "#A2693A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232931,
    stopColor: "#A46239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267131,
    stopColor: "#A6603A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302574,
    stopColor: "#A85939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336152,
    stopColor: "#A95638"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371906,
    stopColor: "#AB5238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407661,
    stopColor: "#AD4D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44155,
    stopColor: "#AD4937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477304,
    stopColor: "#AF4338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510571,
    stopColor: "#AF4237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547258,
    stopColor: "#B03D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581768,
    stopColor: "#AE3A38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615657,
    stopColor: "#AF3638"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65079,
    stopColor: "#AF3537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685611,
    stopColor: "#AE3337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720433,
    stopColor: "#AE3237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756498,
    stopColor: "#AD3037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789143,
    stopColor: "#AE2E38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825208,
    stopColor: "#AD3138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860652,
    stopColor: "#AD2D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895473,
    stopColor: "#AC2F38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.930606,
    stopColor: "#AD2D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963873,
    stopColor: "#AB2E38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB2E38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_240_33903",
    x1: 26.8349,
    y1: 21.0444,
    x2: 26.8349,
    y2: 29.2019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93813D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0232994,
    stopColor: "#947E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0448692,
    stopColor: "#957C3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0798063,
    stopColor: "#97793E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113224,
    stopColor: "#98743D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148162,
    stopColor: "#9C723D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182187,
    stopColor: "#9D6B3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216213,
    stopColor: "#9F673C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249631,
    stopColor: "#A2623A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283353,
    stopColor: "#A25E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317682,
    stopColor: "#A45A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352619,
    stopColor: "#A65438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386645,
    stopColor: "#A85039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.420367,
    stopColor: "#A94C39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#AA4837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488722,
    stopColor: "#A94438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522444,
    stopColor: "#AA4038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557381,
    stopColor: "#AB3D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591103,
    stopColor: "#AA3B38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625433,
    stopColor: "#AB3737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659154,
    stopColor: "#AB3537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692876,
    stopColor: "#AC3338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726902,
    stopColor: "#A93237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762143,
    stopColor: "#AA3037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795561,
    stopColor: "#AA3039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829283,
    stopColor: "#A92F38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863916,
    stopColor: "#A92F38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898246,
    stopColor: "#A92D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932271,
    stopColor: "#AA2E38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965082,
    stopColor: "#AA2E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A82E39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_240_33903",
    x1: 26.6504,
    y1: 20.952,
    x2: 26.6504,
    y2: 29.2022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F833D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0332441,
    stopColor: "#917F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0558874,
    stopColor: "#937D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0896538,
    stopColor: "#94793E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.123817,
    stopColor: "#97743C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157981,
    stopColor: "#98713C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19135,
    stopColor: "#9C6D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225116,
    stopColor: "#9D673D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25928,
    stopColor: "#A0633C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292649,
    stopColor: "#A15D3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325843,
    stopColor: "#A2593A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359387,
    stopColor: "#A4543A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393551,
    stopColor: "#A5513A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427317,
    stopColor: "#A64C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461083,
    stopColor: "#A74738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496439,
    stopColor: "#A74438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528219,
    stopColor: "#A84038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561191,
    stopColor: "#A73D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595354,
    stopColor: "#A83B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629518,
    stopColor: "#A73837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662887,
    stopColor: "#A73637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697051,
    stopColor: "#A83338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729625,
    stopColor: "#A73237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764186,
    stopColor: "#A73038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79835,
    stopColor: "#A73138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830527,
    stopColor: "#A73038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865088,
    stopColor: "#A62E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899251,
    stopColor: "#A62E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932223,
    stopColor: "#A62E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966387,
    stopColor: "#A62F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A62E3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_240_33903",
    x1: 26.4651,
    y1: 20.9518,
    x2: 26.4651,
    y2: 29.2947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0327674,
    stopColor: "#8F803F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0676199,
    stopColor: "#907B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.100387,
    stopColor: "#91783E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133452,
    stopColor: "#94743F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167113,
    stopColor: "#95723E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198689,
    stopColor: "#976C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232648,
    stopColor: "#99663C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266607,
    stopColor: "#9B623C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.299672,
    stopColor: "#9E5D3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333035,
    stopColor: "#9F593B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366994,
    stopColor: "#9F533A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399762,
    stopColor: "#A0503A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434018,
    stopColor: "#A24A38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467382,
    stopColor: "#A24638"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499851,
    stopColor: "#A4433A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533512,
    stopColor: "#A43F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566279,
    stopColor: "#A33C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59994,
    stopColor: "#A33A38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633006,
    stopColor: "#A23736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666369,
    stopColor: "#A4353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699732,
    stopColor: "#A33439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732797,
    stopColor: "#A3323A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766458,
    stopColor: "#A3323A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800119,
    stopColor: "#A33039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833482,
    stopColor: "#A22F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866548,
    stopColor: "#A22F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899613,
    stopColor: "#A22E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933274,
    stopColor: "#A22F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966041,
    stopColor: "#A22E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A42E39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_240_33903",
    x1: 26.2788,
    y1: 20.8595,
    x2: 26.2788,
    y2: 29.3877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0322843,
    stopColor: "#8A813F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0544703,
    stopColor: "#8B8041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0865168,
    stopColor: "#8E7B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119796,
    stopColor: "#8E773F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153075,
    stopColor: "#91733D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184711,
    stopColor: "#936F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21799,
    stopColor: "#956A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250858,
    stopColor: "#99653C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282493,
    stopColor: "#9A613B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315772,
    stopColor: "#9B5B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348641,
    stopColor: "#9C573B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.381509,
    stopColor: "#9D533B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412323,
    stopColor: "#9E4D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445191,
    stopColor: "#9E4A39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47847,
    stopColor: "#A0453B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510927,
    stopColor: "#A14239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542563,
    stopColor: "#A23E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576664,
    stopColor: "#A23A38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608299,
    stopColor: "#A23839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640757,
    stopColor: "#A23539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674036,
    stopColor: "#A1353A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706082,
    stopColor: "#A1333A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738129,
    stopColor: "#A1313A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771819,
    stopColor: "#A1303A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805098,
    stopColor: "#A02F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836733,
    stopColor: "#A02F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869601,
    stopColor: "#A02E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902059,
    stopColor: "#A02E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936159,
    stopColor: "#A02E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966563,
    stopColor: "#A02E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A12E3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_240_33903",
    x1: 32.8542,
    y1: 32.8185,
    x2: 37.7316,
    y2: 37.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE3632"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF3132"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_240_33903",
    x1: 34.6847,
    y1: 30.1866,
    x2: 40.7995,
    y2: 33.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF4934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E14531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_240_33903",
    x1: 19.8531,
    y1: 33.8511,
    x2: 18.2527,
    y2: 37.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#732D67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_240_33903",
    x1: 17.7897,
    y1: 34.7024,
    x2: 19.39,
    y2: 32.0965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C2871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#633167"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_240_33903",
    x1: 32.4157,
    y1: 17.5155,
    x2: 35.9507,
    y2: 14.8846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2AF39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBAE34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_240_33903",
    x1: 30.5838,
    y1: 17.4384,
    x2: 32.6225,
    y2: 15.2714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4AF3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBAE3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_240_33903",
    x1: 26.5422,
    y1: 14.4716,
    x2: 27.2136,
    y2: 12.1225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FAF47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FBB43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_240_33903",
    x1: 25.3775,
    y1: 13.5311,
    x2: 24.9719,
    y2: 16.4678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84B547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67AC4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_240_33903",
    x1: 14.0464,
    y1: 23.3376,
    x2: 15.6962,
    y2: 22.3313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#365D72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_240_33903",
    x1: 15.6959,
    y1: 22.3585,
    x2: 16.8703,
    y2: 21.6877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#365D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34636A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_240_33903",
    x1: 15.5268,
    y1: 24.6795,
    x2: 16.7572,
    y2: 23.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4E75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_240_33903",
    x1: 15.499,
    y1: 24.5961,
    x2: 14.4363,
    y2: 25.6864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4483"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_240_33903",
    x1: 16.7296,
    y1: 26.1342,
    x2: 12.1423,
    y2: 33.1523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F487B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345818,
    stopColor: "#482E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45218D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_240_33903",
    x1: 15.331,
    y1: 32.7904,
    x2: 16.9537,
    y2: 26.2464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A268A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477012,
    stopColor: "#4B2A89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F477C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_240_33903",
    x1: 17.6082,
    y1: 32.4317,
    x2: 17.6082,
    y2: 28.9221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#562A81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433823,
    stopColor: "#542F76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E307E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_240_33903",
    x1: 19.9553,
    y1: 33.8248,
    x2: 21.787,
    y2: 32.9479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E2F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#783153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_240_33903",
    x1: 23.9803,
    y1: 36.3281,
    x2: 23.9028,
    y2: 33.5411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#992842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#982F45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_240_33903",
    x1: 32.1832,
    y1: 30.2897,
    x2: 32.1832,
    y2: 35.4515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D42133"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_240_33903",
    x1: 32.3898,
    y1: 29.9025,
    x2: 35.8735,
    y2: 33.2043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2B31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_240_33903",
    x1: 33.6538,
    y1: 27.5799,
    x2: 36.9822,
    y2: 29.7722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF4435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE4032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_240_33903",
    x1: 33.2659,
    y1: 22.0057,
    x2: 36.5687,
    y2: 24.4819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D78037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E16634"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_240_33903",
    x1: 31.7964,
    y1: 19.4768,
    x2: 35.2281,
    y2: 21.7981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC9939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE8936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_240_33903",
    x1: 30.5329,
    y1: 18.161,
    x2: 32.158,
    y2: 18.4447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3AF3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCA43A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_240_33903",
    x1: 27.284,
    y1: 16.7148,
    x2: 30.4767,
    y2: 15.8255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98AC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8AF3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_240_33903",
    x1: 28.6056,
    y1: 16.0167,
    x2: 26.3405,
    y2: 15.1741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3B342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74B049"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_240_33903",
    x1: 26.6188,
    y1: 16.0309,
    x2: 24.8296,
    y2: 16.1636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75B049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67AC4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_240_33903",
    x1: 23.4305,
    y1: 15.5781,
    x2: 24.36,
    y2: 16.6357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66B14E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67AC4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_240_33903",
    x1: 26.0949,
    y1: 20.8594,
    x2: 26.0949,
    y2: 29.3877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0312699,
    stopColor: "#878041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0543484,
    stopColor: "#887F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0869565,
    stopColor: "#897C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119463,
    stopColor: "#8C7740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151607,
    stopColor: "#8D733E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184989,
    stopColor: "#90703F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.217134,
    stopColor: "#916A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249279,
    stopColor: "#92663B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282248,
    stopColor: "#96613C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316041,
    stopColor: "#965C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348598,
    stopColor: "#99573B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.380331,
    stopColor: "#9A533A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412888,
    stopColor: "#9B4D3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445858,
    stopColor: "#9A4A39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478415,
    stopColor: "#9C463A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510972,
    stopColor: "#9E433A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544353,
    stopColor: "#9C3F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576087,
    stopColor: "#9C3C39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609055,
    stopColor: "#9E3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641612,
    stopColor: "#9C3739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673757,
    stopColor: "#9D3439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706726,
    stopColor: "#9D3439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739695,
    stopColor: "#9E3239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772665,
    stopColor: "#9E313A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80481,
    stopColor: "#9D303B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836542,
    stopColor: "#9D303B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869924,
    stopColor: "#9C2F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901657,
    stopColor: "#9C2F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935038,
    stopColor: "#9D2E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967391,
    stopColor: "#9D303B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D303B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_240_33903",
    x1: 25.9091,
    y1: 20.7664,
    x2: 25.9091,
    y2: 29.3874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0318833,
    stopColor: "#838442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0641702,
    stopColor: "#848040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0964571,
    stopColor: "#867C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129609,
    stopColor: "#897841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161896,
    stopColor: "#8A733F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193318,
    stopColor: "#8B6F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225893,
    stopColor: "#8D6C3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25818,
    stopColor: "#8F653E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.290467,
    stopColor: "#92613D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322177,
    stopColor: "#945B3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354464,
    stopColor: "#93583B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387039,
    stopColor: "#96533D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419038,
    stopColor: "#974F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451325,
    stopColor: "#984B3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4839,
    stopColor: "#984639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516187,
    stopColor: "#984339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548474,
    stopColor: "#9A403A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580184,
    stopColor: "#983C39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613047,
    stopColor: "#9B3A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644181,
    stopColor: "#99383A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677045,
    stopColor: "#993639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709908,
    stopColor: "#9A343A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742195,
    stopColor: "#993339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773617,
    stopColor: "#99323B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807057,
    stopColor: "#98323A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839344,
    stopColor: "#98323A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871631,
    stopColor: "#98313C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.903341,
    stopColor: "#99303A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935628,
    stopColor: "#99303C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967915,
    stopColor: "#9A2F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A2F3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_240_33903",
    x1: 25.7227,
    y1: 20.7665,
    x2: 25.7227,
    y2: 29.4802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F8642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0426673,
    stopColor: "#818242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0748959,
    stopColor: "#827F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106269,
    stopColor: "#847B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138498,
    stopColor: "#857740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.170441,
    stopColor: "#89733F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201244,
    stopColor: "#896E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234613,
    stopColor: "#8B693E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265986,
    stopColor: "#8E643D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2985,
    stopColor: "#8D5F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329873,
    stopColor: "#925C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363242,
    stopColor: "#93573E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392619,
    stopColor: "#93533C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425988,
    stopColor: "#944D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457932,
    stopColor: "#95493B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488734,
    stopColor: "#95463C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522389,
    stopColor: "#96423C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553191,
    stopColor: "#963F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584565,
    stopColor: "#973C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617078,
    stopColor: "#953A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648737,
    stopColor: "#96373B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680965,
    stopColor: "#99333A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712623,
    stopColor: "#96343B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743711,
    stopColor: "#96333A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77651,
    stopColor: "#96313C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808168,
    stopColor: "#96313C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.840682,
    stopColor: "#95313B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872911,
    stopColor: "#95313B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.903999,
    stopColor: "#97303B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936227,
    stopColor: "#972F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968085,
    stopColor: "#97303B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99303C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_240_33903",
    x1: 25.5378,
    y1: 20.7665,
    x2: 25.5378,
    y2: 29.4802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C8844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0209863,
    stopColor: "#7B8642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416047,
    stopColor: "#7D8243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0749112,
    stopColor: "#7E7E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107689,
    stopColor: "#807B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137824,
    stopColor: "#817741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.170073,
    stopColor: "#847241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201793,
    stopColor: "#856E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234571,
    stopColor: "#866A3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265763,
    stopColor: "#88653E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.298012,
    stopColor: "#8C603E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33079,
    stopColor: "#8B5C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362511,
    stopColor: "#8E573E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393703,
    stopColor: "#8E543D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424894,
    stopColor: "#904D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457144,
    stopColor: "#90493C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487278,
    stopColor: "#92463B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521113,
    stopColor: "#90423C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552834,
    stopColor: "#923F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584026,
    stopColor: "#913C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616804,
    stopColor: "#923A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.649581,
    stopColor: "#92383C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681302,
    stopColor: "#93363C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713023,
    stopColor: "#92353C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7458,
    stopColor: "#93343C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775935,
    stopColor: "#92333C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808713,
    stopColor: "#92313B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839376,
    stopColor: "#91323B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872154,
    stopColor: "#92313B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904932,
    stopColor: "#92313B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937181,
    stopColor: "#93313B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967315,
    stopColor: "#92303C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97303B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_240_33903",
    x1: 25.353,
    y1: 20.7666,
    x2: 25.353,
    y2: 29.4803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#788844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0213216,
    stopColor: "#788644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0411755,
    stopColor: "#7B8344"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0752109,
    stopColor: "#7B7F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105843,
    stopColor: "#7D7B42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138744,
    stopColor: "#7F7742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169375,
    stopColor: "#817441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202276,
    stopColor: "#826E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234043,
    stopColor: "#856B40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265242,
    stopColor: "#84653F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.298142,
    stopColor: "#88603F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329342,
    stopColor: "#895C3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.361675,
    stopColor: "#8A573E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392874,
    stopColor: "#8C533E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426342,
    stopColor: "#8C4E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457541,
    stopColor: "#8E4A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489308,
    stopColor: "#8E463D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520507,
    stopColor: "#8F423C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553408,
    stopColor: "#8E3F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586309,
    stopColor: "#8F3B3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618075,
    stopColor: "#8E3A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.649841,
    stopColor: "#90383C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682175,
    stopColor: "#90353C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712807,
    stopColor: "#8F343B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744006,
    stopColor: "#91343B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776339,
    stopColor: "#90323C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808106,
    stopColor: "#90323C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839305,
    stopColor: "#90323C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872773,
    stopColor: "#90323C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904539,
    stopColor: "#8F313B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936873,
    stopColor: "#90313B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968072,
    stopColor: "#91323C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91323C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_240_33903",
    x1: 25.1669,
    y1: 20.7667,
    x2: 25.1669,
    y2: 29.4804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#748743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0206753,
    stopColor: "#758645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042012,
    stopColor: "#778243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0745786,
    stopColor: "#787E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105648,
    stopColor: "#777B42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138214,
    stopColor: "#7B7842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.170407,
    stopColor: "#7C7342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202225,
    stopColor: "#7E6F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234043,
    stopColor: "#816842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266235,
    stopColor: "#816540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.298427,
    stopColor: "#836040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.330245,
    stopColor: "#855C3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362437,
    stopColor: "#86563E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392384,
    stopColor: "#88533F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426447,
    stopColor: "#884E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456768,
    stopColor: "#88493D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489335,
    stopColor: "#89463C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521527,
    stopColor: "#89423C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554093,
    stopColor: "#8A3F3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585911,
    stopColor: "#8B3D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616981,
    stopColor: "#8A3A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646927,
    stopColor: "#8A383E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681365,
    stopColor: "#89373D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71206,
    stopColor: "#8A353C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743878,
    stopColor: "#8B343E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77607,
    stopColor: "#8A343B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809385,
    stopColor: "#8A333D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84008,
    stopColor: "#8B313C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87377,
    stopColor: "#8B313C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.903342,
    stopColor: "#8C323D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937031,
    stopColor: "#8C323D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968849,
    stopColor: "#8D323D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D323D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_240_33903",
    x1: 24.9825,
    y1: 20.7666,
    x2: 24.9825,
    y2: 29.4803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F8844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0207543,
    stopColor: "#718545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0428773,
    stopColor: "#718444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0737927,
    stopColor: "#727F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106694,
    stopColor: "#757B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138176,
    stopColor: "#777842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17051,
    stopColor: "#797342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20256,
    stopColor: "#7A6F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234043,
    stopColor: "#7C6B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265525,
    stopColor: "#7E6541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.298426,
    stopColor: "#7D6040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.330192,
    stopColor: "#805D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362242,
    stopColor: "#815740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393725,
    stopColor: "#835240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425491,
    stopColor: "#844F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457258,
    stopColor: "#844A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489308,
    stopColor: "#85453F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521074,
    stopColor: "#86423F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553124,
    stopColor: "#86403F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584607,
    stopColor: "#853D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616373,
    stopColor: "#863B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.649274,
    stopColor: "#86393D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68104,
    stopColor: "#87373C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712239,
    stopColor: "#87353D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744289,
    stopColor: "#87353D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776623,
    stopColor: "#86343E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807538,
    stopColor: "#87333E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.840439,
    stopColor: "#87323D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871922,
    stopColor: "#87323D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.903688,
    stopColor: "#88333E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936022,
    stopColor: "#89323E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968072,
    stopColor: "#89323C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A323F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_240_33903",
    x1: 24.7969,
    y1: 20.7667,
    x2: 24.7969,
    y2: 29.4804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C8845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0210379,
    stopColor: "#6F8747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04231,
    stopColor: "#6F8345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0732255,
    stopColor: "#707F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105843,
    stopColor: "#717B44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137325,
    stopColor: "#747745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169092,
    stopColor: "#747443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201142,
    stopColor: "#776F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233759,
    stopColor: "#786A42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266093,
    stopColor: "#786441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29871,
    stopColor: "#7C6042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329058,
    stopColor: "#7D5D42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.360541,
    stopColor: "#7E5741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394009,
    stopColor: "#7F5340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426059,
    stopColor: "#7F4E3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457825,
    stopColor: "#804A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489024,
    stopColor: "#82463F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521641,
    stopColor: "#81443F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553124,
    stopColor: "#82403E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585741,
    stopColor: "#833E3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617508,
    stopColor: "#823B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64899,
    stopColor: "#82393E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681324,
    stopColor: "#84363E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71309,
    stopColor: "#84363E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744573,
    stopColor: "#83353E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776907,
    stopColor: "#84333E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808106,
    stopColor: "#85333E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839588,
    stopColor: "#84323E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871355,
    stopColor: "#84323E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904539,
    stopColor: "#86323E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936022,
    stopColor: "#86323E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968072,
    stopColor: "#87303F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85333E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_240_33903",
    x1: 24.6114,
    y1: 20.7666,
    x2: 24.6114,
    y2: 29.4803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#688745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0221726,
    stopColor: "#698545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042012,
    stopColor: "#6C8345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0745786,
    stopColor: "#6C7F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106771,
    stopColor: "#6E7B45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138214,
    stopColor: "#6F7645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.170032,
    stopColor: "#707343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202225,
    stopColor: "#716E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234043,
    stopColor: "#746B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265486,
    stopColor: "#766442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297678,
    stopColor: "#756142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.330619,
    stopColor: "#785C42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36094,
    stopColor: "#795640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393881,
    stopColor: "#7B5341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425324,
    stopColor: "#7B4E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457142,
    stopColor: "#7C4A40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48896,
    stopColor: "#7D463F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521527,
    stopColor: "#7C433F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553719,
    stopColor: "#7D3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585911,
    stopColor: "#7D3D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617355,
    stopColor: "#7F3B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648799,
    stopColor: "#7F393E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680991,
    stopColor: "#7D373E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712434,
    stopColor: "#7E363E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744627,
    stopColor: "#7F363E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776445,
    stopColor: "#7E343E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808262,
    stopColor: "#80333E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.840455,
    stopColor: "#81333E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87115,
    stopColor: "#81333E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.903716,
    stopColor: "#81333D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937406,
    stopColor: "#84333E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968101,
    stopColor: "#84323E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84323E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_240_33903",
    x1: 24.4268,
    y1: 20.7667,
    x2: 24.4268,
    y2: 29.4804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#658747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0207543,
    stopColor: "#678647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04231,
    stopColor: "#688348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0740764,
    stopColor: "#698046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106694,
    stopColor: "#6A7B46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138176,
    stopColor: "#6B7644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.170226,
    stopColor: "#6E7245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201425,
    stopColor: "#6E6E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234326,
    stopColor: "#716845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266093,
    stopColor: "#746544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297292,
    stopColor: "#736043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.330192,
    stopColor: "#755C42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362242,
    stopColor: "#765742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393441,
    stopColor: "#785143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425491,
    stopColor: "#784E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457541,
    stopColor: "#794A40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489308,
    stopColor: "#784740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520507,
    stopColor: "#7A4340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55199,
    stopColor: "#7A4141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585174,
    stopColor: "#7B3D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616089,
    stopColor: "#7B3B40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64899,
    stopColor: "#7C3940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680189,
    stopColor: "#7B363E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712807,
    stopColor: "#7C373F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744857,
    stopColor: "#7D363E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777474,
    stopColor: "#7D3540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808673,
    stopColor: "#7E3440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.840156,
    stopColor: "#7D333F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871071,
    stopColor: "#7F323D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.903688,
    stopColor: "#803340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936305,
    stopColor: "#80323D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967788,
    stopColor: "#81333E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83323E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_240_33903",
    x1: 24.2397,
    y1: 20.7665,
    x2: 24.2397,
    y2: 29.4802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#618647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0216052,
    stopColor: "#628647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0417428,
    stopColor: "#648247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0740764,
    stopColor: "#657E46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10641,
    stopColor: "#667A46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137893,
    stopColor: "#687645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169943,
    stopColor: "#687245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201993,
    stopColor: "#6A6D45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234043,
    stopColor: "#6C6845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266093,
    stopColor: "#6D6344"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297859,
    stopColor: "#6F5F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329625,
    stopColor: "#705A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.361392,
    stopColor: "#715744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394009,
    stopColor: "#735243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425491,
    stopColor: "#724D42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457541,
    stopColor: "#734A40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488741,
    stopColor: "#754542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520507,
    stopColor: "#764341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55284,
    stopColor: "#764041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584323,
    stopColor: "#763E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616657,
    stopColor: "#783B40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648139,
    stopColor: "#78393F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679906,
    stopColor: "#783740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712523,
    stopColor: "#783740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743722,
    stopColor: "#7A3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775772,
    stopColor: "#7A3541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808389,
    stopColor: "#7A353F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.840723,
    stopColor: "#7C343F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871638,
    stopColor: "#7C3441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.903972,
    stopColor: "#7D343F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936022,
    stopColor: "#7D343F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968072,
    stopColor: "#803340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F323F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_240_33903",
    x1: 24.0562,
    y1: 20.8594,
    x2: 24.0562,
    y2: 29.3877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0213467,
    stopColor: "#608347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0542388,
    stopColor: "#608046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0871309,
    stopColor: "#627B45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119258,
    stopColor: "#637645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151003,
    stopColor: "#647345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185042,
    stopColor: "#656E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.217552,
    stopColor: "#666A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249297,
    stopColor: "#6A6545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282189,
    stopColor: "#6A6044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313933,
    stopColor: "#6C5B44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34912,
    stopColor: "#6E5743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379335,
    stopColor: "#6D5442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411462,
    stopColor: "#6F4F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445884,
    stopColor: "#704B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478394,
    stopColor: "#714742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510903,
    stopColor: "#704442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54303,
    stopColor: "#724142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575923,
    stopColor: "#733F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608432,
    stopColor: "#723D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640177,
    stopColor: "#743A40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673069,
    stopColor: "#743841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706343,
    stopColor: "#743642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739236,
    stopColor: "#753640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770598,
    stopColor: "#753640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804637,
    stopColor: "#763540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837529,
    stopColor: "#783440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869274,
    stopColor: "#783440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901019,
    stopColor: "#793440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935058,
    stopColor: "#7B3340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968333,
    stopColor: "#7D3341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_240_33903",
    x1: 23.8713,
    y1: 20.9517,
    x2: 23.8713,
    y2: 29.2946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D8549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0327424,
    stopColor: "#5C8048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0675848,
    stopColor: "#5F7D47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0996867,
    stopColor: "#607847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133355,
    stopColor: "#617447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167023,
    stopColor: "#627046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199907,
    stopColor: "#636A46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233184,
    stopColor: "#666646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265677,
    stopColor: "#656246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.299345,
    stopColor: "#695E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333796,
    stopColor: "#695945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367073,
    stopColor: "#6A5545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399174,
    stopColor: "#6B4F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433234,
    stopColor: "#6C4D45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466902,
    stopColor: "#6D4843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499787,
    stopColor: "#6F4542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533063,
    stopColor: "#6E4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566731,
    stopColor: "#6E4141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60079,
    stopColor: "#6F3E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632501,
    stopColor: "#6F3B42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665777,
    stopColor: "#703A42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699837,
    stopColor: "#703841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732722,
    stopColor: "#723841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767564,
    stopColor: "#723641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800057,
    stopColor: "#743542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833334,
    stopColor: "#733340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867002,
    stopColor: "#743441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898712,
    stopColor: "#753441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933163,
    stopColor: "#773341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966831,
    stopColor: "#773341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793342"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_240_33903",
    x1: 23.684,
    y1: 20.9521,
    x2: 23.684,
    y2: 29.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#588348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0332864,
    stopColor: "#598149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0662093,
    stopColor: "#5A7A48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0997254,
    stopColor: "#5C7748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133538,
    stopColor: "#5C7348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166461,
    stopColor: "#5F6D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19968,
    stopColor: "#606B46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233493,
    stopColor: "#616547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266713,
    stopColor: "#626147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300525,
    stopColor: "#635D45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333745,
    stopColor: "#655845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366668,
    stopColor: "#665445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399591,
    stopColor: "#664F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433996,
    stopColor: "#684C44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467216,
    stopColor: "#694844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500139,
    stopColor: "#6A4444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533358,
    stopColor: "#6A4243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566281,
    stopColor: "#6B3F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.599797,
    stopColor: "#6C3E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633907,
    stopColor: "#6C3B42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666236,
    stopColor: "#6C3A42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.700049,
    stopColor: "#6D3841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732379,
    stopColor: "#6D3642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766191,
    stopColor: "#6E3642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800004,
    stopColor: "#703542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832334,
    stopColor: "#703541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866443,
    stopColor: "#713441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898773,
    stopColor: "#733441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931992,
    stopColor: "#743442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966102,
    stopColor: "#753342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773342"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_240_33903",
    x1: 23.4995,
    y1: 21.0448,
    x2: 23.4995,
    y2: 29.2023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#558148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0223615,
    stopColor: "#577E49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0451139,
    stopColor: "#567C49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.079091,
    stopColor: "#587849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113978,
    stopColor: "#5A7448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.147955,
    stopColor: "#5B6E49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181629,
    stopColor: "#5C6B49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215909,
    stopColor: "#5C6847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249886,
    stopColor: "#5F6249"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28447,
    stopColor: "#605D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317537,
    stopColor: "#625A47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35212,
    stopColor: "#625546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386704,
    stopColor: "#645045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419771,
    stopColor: "#644C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453748,
    stopColor: "#654945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488332,
    stopColor: "#674646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522006,
    stopColor: "#664345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556589,
    stopColor: "#674044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591173,
    stopColor: "#683D44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62515,
    stopColor: "#693C44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65852,
    stopColor: "#6A3B44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692497,
    stopColor: "#6B3943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727384,
    stopColor: "#6B3744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761665,
    stopColor: "#6C3744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795642,
    stopColor: "#6C3742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829315,
    stopColor: "#6D3642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863293,
    stopColor: "#703542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.897269,
    stopColor: "#703542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931247,
    stopColor: "#713442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964955,
    stopColor: "#713442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#733441"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_240_33903",
    x1: 23.3143,
    y1: 21.1371,
    x2: 23.3143,
    y2: 29.1092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#518048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0343303,
    stopColor: "#537C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582608,
    stopColor: "#54794A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0930687,
    stopColor: "#55744A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127566,
    stopColor: "#567048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.162374,
    stopColor: "#576B49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197492,
    stopColor: "#586848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23199,
    stopColor: "#5B6348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267108,
    stopColor: "#5D5F48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.301295,
    stopColor: "#5D5B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338278,
    stopColor: "#5F5647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.372465,
    stopColor: "#605247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406962,
    stopColor: "#614E47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44177,
    stopColor: "#624A47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476577,
    stopColor: "#614745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511385,
    stopColor: "#624346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547436,
    stopColor: "#634145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581312,
    stopColor: "#643E46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61612,
    stopColor: "#653C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.650617,
    stopColor: "#663A46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686047,
    stopColor: "#663A46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720855,
    stopColor: "#673745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755352,
    stopColor: "#693745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79047,
    stopColor: "#693745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825589,
    stopColor: "#6A3645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860086,
    stopColor: "#6B3545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895205,
    stopColor: "#6C3545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.930013,
    stopColor: "#6C3543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964821,
    stopColor: "#6F3443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#703544"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_240_33903",
    x1: 23.1289,
    y1: 21.1371,
    x2: 23.1289,
    y2: 29.0165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#507F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0227854,
    stopColor: "#507D4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0469974,
    stopColor: "#507A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0822148,
    stopColor: "#50764A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117432,
    stopColor: "#537249"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15265,
    stopColor: "#546E49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188182,
    stopColor: "#536849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224028,
    stopColor: "#576248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259245,
    stopColor: "#576048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293834,
    stopColor: "#5A5B49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329366,
    stopColor: "#5B5748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#5C5348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.400115,
    stopColor: "#5C4E48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435961,
    stopColor: "#5C4B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.470236,
    stopColor: "#5F4648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506082,
    stopColor: "#5F4547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541614,
    stopColor: "#614248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575573,
    stopColor: "#613E47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.611734,
    stopColor: "#613D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64758,
    stopColor: "#623C47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682353,
    stopColor: "#633A46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717701,
    stopColor: "#643946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752289,
    stopColor: "#643845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788136,
    stopColor: "#653745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823982,
    stopColor: "#663645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858571,
    stopColor: "#663645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894417,
    stopColor: "#693545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92932,
    stopColor: "#693545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964852,
    stopColor: "#6B3545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C3545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_240_33903",
    x1: 22.9438,
    y1: 21.3226,
    x2: 22.9438,
    y2: 28.9239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C7C4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0245947,
    stopColor: "#4E794B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0469872,
    stopColor: "#4D764A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0853127,
    stopColor: "#50724A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121916,
    stopColor: "#526C49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158088,
    stopColor: "#526949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195553,
    stopColor: "#526549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232156,
    stopColor: "#566149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268328,
    stopColor: "#565C48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304931,
    stopColor: "#575748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341534,
    stopColor: "#595549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378137,
    stopColor: "#5A5048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415171,
    stopColor: "#5B4C48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.450482,
    stopColor: "#5B4948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487947,
    stopColor: "#5C4649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52455,
    stopColor: "#5D4448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561153,
    stopColor: "#5F4047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597325,
    stopColor: "#5F3D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634359,
    stopColor: "#5F3C47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.670531,
    stopColor: "#603B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706704,
    stopColor: "#603848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743737,
    stopColor: "#623748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.780771,
    stopColor: "#623746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816082,
    stopColor: "#643646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852685,
    stopColor: "#643546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89058,
    stopColor: "#653546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.926753,
    stopColor: "#653546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962925,
    stopColor: "#693545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C3446"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_240_33903",
    x1: 22.7579,
    y1: 21.4156,
    x2: 22.7579,
    y2: 28.8315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B794A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0355565,
    stopColor: "#4B754B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0629417,
    stopColor: "#4C734A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.100928,
    stopColor: "#4C6D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137147,
    stopColor: "#4E694A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175133,
    stopColor: "#4E6649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.212235,
    stopColor: "#506149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250221,
    stopColor: "#525E4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287323,
    stopColor: "#535849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324867,
    stopColor: "#53544A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362412,
    stopColor: "#56514B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.400398,
    stopColor: "#564D4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#56494A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475044,
    stopColor: "#58464B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512588,
    stopColor: "#5A444A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550574,
    stopColor: "#5B404B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587235,
    stopColor: "#5B3E4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623896,
    stopColor: "#5D3C4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663207,
    stopColor: "#5D3A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699867,
    stopColor: "#5F394A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737412,
    stopColor: "#5F3749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775398,
    stopColor: "#5E3648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812058,
    stopColor: "#5F3749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.850486,
    stopColor: "#623549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88803,
    stopColor: "#633447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925133,
    stopColor: "#643447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962235,
    stopColor: "#653347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#673549"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_240_33903",
    x1: 22.5722,
    y1: 21.5083,
    x2: 22.5722,
    y2: 28.7388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#487849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0373241,
    stopColor: "#48734B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0768138,
    stopColor: "#4A6F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115273,
    stopColor: "#4C6A4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154076,
    stopColor: "#4E664B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192536,
    stopColor: "#4F614B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230309,
    stopColor: "#4F5E4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269112,
    stopColor: "#51594A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307228,
    stopColor: "#51574B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346031,
    stopColor: "#51514C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38449,
    stopColor: "#544E4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422607,
    stopColor: "#564A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460379,
    stopColor: "#56484B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499869,
    stopColor: "#57454C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538672,
    stopColor: "#58404C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576788,
    stopColor: "#583E4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614905,
    stopColor: "#5A3E4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.653708,
    stopColor: "#5A3B4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692854,
    stopColor: "#5B394B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730283,
    stopColor: "#5C384B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769086,
    stopColor: "#5E374A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807202,
    stopColor: "#5E354A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.845319,
    stopColor: "#60354A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884122,
    stopColor: "#60354A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922925,
    stopColor: "#613448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961727,
    stopColor: "#633448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66354A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_240_33903",
    x1: 22.3874,
    y1: 21.6937,
    x2: 22.3874,
    y2: 28.5535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45734C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0403358,
    stopColor: "#466E4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0679771,
    stopColor: "#486B4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107903,
    stopColor: "#49674C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148853,
    stopColor: "#4A644D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189292,
    stopColor: "#4B5F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230242,
    stopColor: "#4E5B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269656,
    stopColor: "#4D574E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310094,
    stopColor: "#50534C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352068,
    stopColor: "#4F4F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392506,
    stopColor: "#514C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431921,
    stopColor: "#52494D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472871,
    stopColor: "#53454D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512797,
    stopColor: "#55424E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553747,
    stopColor: "#55404D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595209,
    stopColor: "#563E4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635135,
    stopColor: "#563C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676597,
    stopColor: "#583B4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7155,
    stopColor: "#58394B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75645,
    stopColor: "#5A384B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796888,
    stopColor: "#5B374B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83835,
    stopColor: "#5D364B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.877764,
    stopColor: "#5D354A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918919,
    stopColor: "#5E354A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958784,
    stopColor: "#60354A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61354A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_240_33903",
    x1: 22.2019,
    y1: 21.7861,
    x2: 22.2019,
    y2: 28.3677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#466E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04239,
    stopColor: "#456C4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069778,
    stopColor: "#46694C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.112105,
    stopColor: "#47644C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154432,
    stopColor: "#48624E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196758,
    stopColor: "#485D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.240081,
    stopColor: "#4A594E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28191,
    stopColor: "#4C554D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324237,
    stopColor: "#4C514D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365568,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408392,
    stopColor: "#4F4A4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.450719,
    stopColor: "#50464F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492548,
    stopColor: "#51444E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534875,
    stopColor: "#51404D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5777,
    stopColor: "#53404D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619031,
    stopColor: "#543D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661357,
    stopColor: "#553C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705178,
    stopColor: "#573A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746509,
    stopColor: "#573A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788836,
    stopColor: "#58374C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831661,
    stopColor: "#58374C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871996,
    stopColor: "#5A364C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915318,
    stopColor: "#5C354C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958143,
    stopColor: "#5D344C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E344A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_240_33903",
    x1: 22.0169,
    y1: 21.9716,
    x2: 22.0169,
    y2: 28.1824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#446A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0455224,
    stopColor: "#45694E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0597015,
    stopColor: "#45684D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105224,
    stopColor: "#45624D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149254,
    stopColor: "#475F4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19403,
    stopColor: "#475B4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239552,
    stopColor: "#49574F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283582,
    stopColor: "#4B534E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329104,
    stopColor: "#4B5050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373881,
    stopColor: "#4B4B4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41791,
    stopColor: "#4D484F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462687,
    stopColor: "#4F454F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506716,
    stopColor: "#4F434F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552239,
    stopColor: "#504050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597761,
    stopColor: "#523E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641045,
    stopColor: "#523C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686567,
    stopColor: "#533B4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731343,
    stopColor: "#54394F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776119,
    stopColor: "#54394F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820149,
    stopColor: "#57374F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864179,
    stopColor: "#58374E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910448,
    stopColor: "#59364E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957463,
    stopColor: "#5A354E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E354E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_240_33903",
    x1: 21.8316,
    y1: 27.9972,
    x2: 21.8316,
    y2: 22.1572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59344F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0321429,
    stopColor: "#583750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0646825,
    stopColor: "#56364F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0968254,
    stopColor: "#56364F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.126984,
    stopColor: "#55374F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15873,
    stopColor: "#543850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189683,
    stopColor: "#53374F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222222,
    stopColor: "#543950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253175,
    stopColor: "#523A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285714,
    stopColor: "#513A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318254,
    stopColor: "#523B51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#513C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.380952,
    stopColor: "#503D51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412698,
    stopColor: "#503F51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442857,
    stopColor: "#4E4051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47619,
    stopColor: "#4E4152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509524,
    stopColor: "#4E4351"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540476,
    stopColor: "#4C4551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571429,
    stopColor: "#4B4750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603968,
    stopColor: "#4A4951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635714,
    stopColor: "#4A4B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665873,
    stopColor: "#4A4D50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699206,
    stopColor: "#484E50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730159,
    stopColor: "#475450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761905,
    stopColor: "#485551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793651,
    stopColor: "#45574F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825397,
    stopColor: "#465A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856349,
    stopColor: "#445D4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888889,
    stopColor: "#43604F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.920635,
    stopColor: "#43624E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95873,
    stopColor: "#42654D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41684D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_240_33903",
    x1: 21.6465,
    y1: 27.8118,
    x2: 21.6465,
    y2: 22.3426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0331685,
    stopColor: "#543752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0691231,
    stopColor: "#543651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102081,
    stopColor: "#543752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136238,
    stopColor: "#533751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169796,
    stopColor: "#513851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203354,
    stopColor: "#523852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23751,
    stopColor: "#503951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270469,
    stopColor: "#503B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305824,
    stopColor: "#4F3C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338782,
    stopColor: "#4F3C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371741,
    stopColor: "#4F3D53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405898,
    stopColor: "#4C3F53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.440055,
    stopColor: "#4D4052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47541,
    stopColor: "#4C4152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508368,
    stopColor: "#4C4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542525,
    stopColor: "#4A4553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576083,
    stopColor: "#4A4752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61024,
    stopColor: "#4A4953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643198,
    stopColor: "#484B51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677954,
    stopColor: "#474C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711512,
    stopColor: "#474F51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745069,
    stopColor: "#455351"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779825,
    stopColor: "#455452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812184,
    stopColor: "#445851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84754,
    stopColor: "#435A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880498,
    stopColor: "#425C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914655,
    stopColor: "#425F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948812,
    stopColor: "#436150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964991,
    stopColor: "#41634E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41644F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_240_33903",
    x1: 21.4612,
    y1: 22.6206,
    x2: 21.4612,
    y2: 27.5336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E5F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0377358,
    stopColor: "#415D51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0557471,
    stopColor: "#405C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0931036,
    stopColor: "#425951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.131794,
    stopColor: "#425752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.170485,
    stopColor: "#445452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207842,
    stopColor: "#445252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244531,
    stopColor: "#444F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281888,
    stopColor: "#464E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320579,
    stopColor: "#464C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356601,
    stopColor: "#474954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396626,
    stopColor: "#474753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432648,
    stopColor: "#484553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471339,
    stopColor: "#494453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508696,
    stopColor: "#4A4254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548054,
    stopColor: "#4A4053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584743,
    stopColor: "#4C3F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621432,
    stopColor: "#4C3F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658122,
    stopColor: "#4C3D54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69748,
    stopColor: "#4E3B56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736838,
    stopColor: "#4E3B56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774194,
    stopColor: "#4E3955"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811551,
    stopColor: "#503855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846906,
    stopColor: "#503853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886931,
    stopColor: "#503755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924288,
    stopColor: "#513753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962978,
    stopColor: "#533653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#523552"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_240_33903",
    x1: 21.2762,
    y1: 22.9914,
    x2: 21.2762,
    y2: 27.1628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0661111,
    stopColor: "#405652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111111,
    stopColor: "#415253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155556,
    stopColor: "#445254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198889,
    stopColor: "#444F54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244444,
    stopColor: "#444D55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288889,
    stopColor: "#454C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333889,
    stopColor: "#444954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377222,
    stopColor: "#464854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421667,
    stopColor: "#464655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467222,
    stopColor: "#474456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511667,
    stopColor: "#494256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556111,
    stopColor: "#493F57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598889,
    stopColor: "#4A3E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643889,
    stopColor: "#4C3E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688889,
    stopColor: "#4B3D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732778,
    stopColor: "#4C3C57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776667,
    stopColor: "#4C3A56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821667,
    stopColor: "#4D3956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866111,
    stopColor: "#4E3956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911111,
    stopColor: "#503856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.954444,
    stopColor: "#4F3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#503755"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_240_33903",
    x1: 21.0899,
    y1: 23.3249,
    x2: 21.0899,
    y2: 26.8104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#415655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0359043,
    stopColor: "#405353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0904255,
    stopColor: "#415054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144282,
    stopColor: "#425056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196809,
    stopColor: "#444D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#444B57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302527,
    stopColor: "#444956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355053,
    stopColor: "#444757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40758,
    stopColor: "#464557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462766,
    stopColor: "#464358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515957,
    stopColor: "#474157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571809,
    stopColor: "#493F57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628324,
    stopColor: "#493E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681516,
    stopColor: "#493D57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732048,
    stopColor: "#4B3C59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785239,
    stopColor: "#4B3A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839761,
    stopColor: "#4C3B57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892287,
    stopColor: "#4E3A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946809,
    stopColor: "#4D3757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#503758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_240_33903",
    x1: 20.905,
    y1: 23.8256,
    x2: 20.905,
    y2: 26.2914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096859,
    stopColor: "#424C57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17262,
    stopColor: "#424A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245059,
    stopColor: "#444A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321485,
    stopColor: "#434659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399905,
    stopColor: "#454359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473008,
    stopColor: "#464359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548872,
    stopColor: "#474259"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622537,
    stopColor: "#49405A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699628,
    stopColor: "#473E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77406,
    stopColor: "#483C59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849821,
    stopColor: "#493C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924254,
    stopColor: "#4A3B58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B3A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_240_33903",
    x1: 21.0095,
    y1: 18.0252,
    x2: 22.0678,
    y2: 15.5733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#409E53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57AF4E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSbt);
export default __webpack_public_path__ + "static/media/logo-sbt.daf3fe10d27307bfd6102629ca0c8e5a.svg";
export { ForwardRef as ReactComponent };